// GAMMEL-OTTAR – tekstbibliotek
// Håndskrevne tekstblokker i én konsekvent Ottar-stemme.
// Utvidet Season 2-bibliotek med karakterhistorier og stjernetegn-humor.
// mytiske: {title, text}. Alt anna: strengar.
window.OTTAR = {
  "openings": [
    "Hør no her. Havet har allerede sagt sitt. Nu e det min tur.",
    "Sett dæ ned litt. Stående folk høre sjelden etter.",
    "Nu ska du høre. Om du like det eller ikkje, e ikkje mitt problem.",
    "Æ kom til å tenke på dæ i morges. Det va ikkje et godt tegn.",
    "Æ har sett verre. Men ikkje mange som kom så godt i gang.",
    "Det finnes verre. Men æ ville ikkje brukt det som trøst.",
    "Havet sa nåkka i morges. Æ trur det va mynta på dæ.",
    "Måsan skreik som om de visste ka du hold på med.",
    "Det luktar ei avgjørelse du kjem til å angre på.",
    "Kaffen blei kald mens æ tenkte på dæ. Det skjer sjelden uten grunn.",
    "Æ såg navnet ditt i skummet. Det blei ikkje liggande lenge.",
    "Fjæra fortalte meir om dæ enn du hadde tenkt.",
    "Nordavinden sladra. Den har aldri vært flink til å holde kjeft.",
    "Æ trur du treng det her. Om du vil innrømme det e en annan sak.",
    "Det her e ikkje personleg. Men du kjem nok til å ta det sånn.",
    "Litt personleg blir det alltid når sannheta bland sæ inn.",
    "Æ møtte Ronny i morges. Dagen tok aldri heilt sæ opp etter det.",
    "Det va et dårlig tegn. Ronny va berre bonusen.",
    "Havet rista på haue. Æ gjorde det samme.",
    "Motoren hosta da æ tenkte på dæ. Den pleie å ha rett.",
    "Æ sov dårlig i natt. Havet nevnte navnet ditt fleire ganga.",
    "Måsan flaug mot vinden. Det gjør de berre når folk har tenkt sæ bort.",
    "Det skjer ikkje uten grunn. Det skjer som regel på grunn av folk.",
    "Æ spurte torsken om råd. Han såg berre oppgitt ut.",
    "Han svarte ikkje. Det va kanskje det klokaste han kunne gjort.",
    "Stillheta va svar nok. Den pleie å være det.",
    "Æ treng berre å se på dæ. Resten skjønne æ sjøl.",
    "Du treng ikkje forklare. Forklaringa pleie å gjøre det verre.",
    "Det her kjem du ikkje til å like. Men det betyr ikkje at det e feil.",
    "Æ lika det heller ikkje. Sannheta spør aldri om lov.",
    "Sannheta bryr sæ lite om humøret ditt.",
    "Ka i svarte e det du driv med no?",
    "Nu får vi ta det her før det blir dyrere.",
    "Hysj litt. Høre du ka havet prøve å sei?",
    "Sjøen har meir vett enn oss begge til sammen.",
    "Æ har dårlig nytt. Det gode e at du fortsatt kan gjøre nåkka med det.",
    "Kaffen va middels. Dagen ser ut til å følge samme oppskrift.",
    "Det e omtrent den stemninga æ hadde venta.",
    "Æ såg ei måse flire. Det gjorde mæ meir urolig enn stormvarsel.",
    "Den lo ikkje uten grunn.",
    "Æ va på kaia før sola. Det e da sannheta vise sæ.",
    "Der lærte æ litt om dæ. Du kjem neppe til å like det.",
    "Æ trur ikkje du e klar. Det har aldri stoppa livet før.",
    "Ingen av oss e heilt klar. Det e det som held oss i gang.",
    "Nu e det din tur. Ikkje lat som du ikkje visste den kom.",
    "Havet har venta på dæ lenge nok no.",
    "Æ venta ikkje. Æ visste du kom tidsnok te å få høre det her.",
    "No e du her. Da kan vi like gjerne snakke sant.",
    "Det va stille på kaia. Så kom æ til å tenke på dæ.",
    "Det e rart kor mykje bråk ett menneske kan lage uten å sei et ord."
  ],
  "observations": [ // Observasjoner (50)
    "Æ såg tre måsa sitt heilt stille i morges. Det e aldri et tegn æ lika.",
    "Stillheta kom før sola. Den pleie å varsle et eller anna.",
    "Havet va roligare enn folk flest. Det gjorde mæ mistenksom.",
    "Når sjøen blir for snill, begynne æ å lure på ka den skjule.",
    "Fjæra kom tidlig i dag. Ingen la merke til det utenom havet.",
    "Folk ser på klokka. Havet ser på månen.",
    "Nordavinden snudde uten å spør. Den gjør det når nån har tenkt sæ bort.",
    "Vinden hadde bestemt sæ lenge før du stod opp.",
    "Kaffen smakte jern i dag. Det skjer ikkje uten grunn.",
    "Sånne morgena har æ lært mæ å respektere.",
    "Æ fant et tau med fleire knuta enn fornuft. Det minte mæ om enkelte menneska.",
    "Du ser fort kem som har knytt i mørket.",
    "En skarv stirra på mæ lenge. Han såg ut som han visste meir enn han burde.",
    "Æ stolte meir på blikket hans enn på værmeldinga.",
    "Torsken stod djupare enn vanlig. Det gjør den når overflata blir for bråkete.",
    "Kloke ting ligg sjelden øverst.",
    "Ronny va oppe før sola. Det gjorde mæ meir urolig enn uværet.",
    "Ingen med vett står opp så tidlig uten grunn.",
    "Ei gammal bøye dreiv feil vei. Ho såg tryggare ut enn fleire æ kjenne.",
    "Det e rart ka som held sæ flytande.",
    "Æ høyrte en motor som ikkje ville heim. Den lyden har æ hørt før.",
    "Stahet har sin egen motortone.",
    "Sjøsprøyten traff kaia sjøl om det va blikkstille. Havet hadde ei meining.",
    "Det e ikkje alt som kan forklares med vind.",
    "Æ fant ei tom kaffekanne. Den såg meir sliten ut enn mæ.",
    "Det hadde vore en lang dag før den va tom.",
    "Ei måse stjal matpakken til en turist. Ingen på kaia blei overraska.",
    "Måsan veit kven som ikkje følge med.",
    "Æ såg spor etter rev på stranda. Den hadde planlagt dagen bedre enn folk flest.",
    "Det e forskjell på å være sulten og å være klok.",
    "Havet sa lite i dag. Det e da æ høre best etter.",
    "Stillheta e sjelden tom.",
    "Æ måtte knyte opp samme tau to ganga. Nån hadde hatt meir hastverk enn vett.",
    "Hastverk legg alltid igjen spor.",
    "Æ såg en mann skylde på været. Været tok det ganske pent.",
    "Det e mykje rart folk legg over på vinden.",
    "Ei gammal sjark låg heilt i ro. Den hadde ikkje lenger nåkka å bevise.",
    "Gamle båta rope aldri.",
    "Æ høyrte stillheta før fuglan vakna. Den vare aldri lenge.",
    "Stillheta e alltid på gjennomreise.",
    "En fisk hoppa rett foran båten. Han angra før han traff sjøen igjen.",
    "Det va kanskje dagens klokaste avgjørelse.",
    "Æ fann rust på nytt stål. Tida vente ikkje på nån.",
    "Alt blir gammelt. Nokka berre raskare enn anna.",
    "Bølgan va små. Stoltheita va stor.",
    "Den blandinga har kosta mange båta.",
    "Æ burde gått heim da æ såg det første tegnet.",
    "Men nysgjerrighet har alltid vore sterkare enn vettet mitt.",
    "Kaia va full av folk. Likevel va det havet som sa mest.",
    "Det e rart ka mykje du ser når du slutte å prate."
  ],
  "kaiaStories": [ // Historier fra kaia (50)
    "En kar sa en gang at han hadde full kontroll. Tre daga seinare fant vi kontrollen drivande mellom to bøya.",
    "Æ kjente en fiskar som alltid hadde dårlig tid. Han kom ofte først ut og sist heim.",
    "En ungkar kjøpte ny båt før han lærte å fortøye. Havet tok skolepenga kontant.",
    "En mann lo av værmeldinga. Været venta til han va langt nok ute.",
    "Han som skrøyt mest på kaia, hadde som regel minst å vise fram.",
    "Æ såg en kar bruke tre tima på å spare ti minutt. Han va fornøyd heilt til kvelden kom.",
    "En nabo meinte tau va overvurdert. Båten hans dreiv over til Sverige.",
    "Det kom en søring hit og sa havet såg fredelig ut. Havet tok det personlig.",
    "En kar bytta motor tre ganga. Til slutt foreslo vi å bytte han som styrte.",
    "Han som alltid visste best, spurte aldri om veien. Det syntes godt.",
    "Æ huske en vinter da isen bar alle, bortsett fra han som hadde mest hastverk.",
    "En fiskar telte penga før fangsten va solgt. Han fikk god trening i å telle på nytt.",
    "En kar kjøpte ekkolodd og blei overraska over kor tomt havet kunne være.",
    "Æ møtte en mann som skyldte på måsan. Det va første gangen de va heilt uskyldige.",
    "En gammel sjark holdt lenger enn både eieren og forsikringsselskapet hadde trudd.",
    "Han som lo av redningsvesten, blei den som brukte den mest.",
    "Æ kjente en kar som alltid skulle ha siste ord. Havet fikk det til slutt.",
    "En fiskar rodde mot strømmen berre fordi han ikkje likte rådet om å la være.",
    "Han kom fram. Men han brukte resten av dagen på å forklare koffør det va verdt det.",
    "En mann reparerte alt med strips. Til slutt va det berre stripsan som holdt sammen.",
    "Æ såg en kar kjøpe den billigste vinsjen. Året etter kjøpte han den dyreste.",
    "En nabo sa kaffen va for sterk. Etter det tok vi resten av meiningan hans med litt salt.",
    "Han som aldri glømte nåkka, glømte ofte at livet foregikk mens han holdt orden.",
    "En fiskar snudde én gang for tidlig og angra. Han som ikkje snudde, angra enda meir.",
    "Æ kjente en kar som aldri tok pause. Til slutt tok kroppen pausen for han.",
    "En mann kjøpte større båt for å få mindre problem. Han fikk berre større problem med bedre utsikt.",
    "Han som banna mest på motoren, va sjelden den som hadde sjekka olja.",
    "Æ såg en kar miste lua i vinden. Han jakta lenger på den enn han hadde jakta på fisk.",
    "En fiskar lot været bestemme. Han blei gammel.",
    "Han som lot egoet bestemme, blei mest våt.",
    "En kar lånte verktøy av alle på kaia. Etter kvart måtte han begynne å låne andre plassa.",
    "Ingen sa nei første året. Ingen svarte det neste.",
    "Æ møtte en mann som stolte meir på flaks enn erfaring. Flaksen flytta uten å sei fra.",
    "Han kom heim med mange forklaringa og akkurat nok fisk til å gjøre dem mistenkelige.",
    "En nabo skulle bli rik på en snarvei. Snarveien tok heile sommeren.",
    "En kar bygde brygge uten å måle. Havet målte for han første høststormen.",
    "Æ kjente en fiskar som alltid va sint. Han trudde vinden holdt avstand.",
    "Vinden brydde sæ ikkje.",
    "En mann skifta kurs kvar gang nån ga råd. Han kom aldri langt nok til å bli uenig med seg sjøl.",
    "Æ såg en kar leite halve dagen etter brillan som satt på hodet.",
    "Han fant dem før Ronny ville gjort det.",
    "En fiskar sa «det ordne sæ». Det gjorde det. Berre ikkje på hans måte.",
    "En gammel skipper sa havet tilgir mykje, men aldri arroganse.",
    "Æ har sett nok til å tru på han.",
    "Æ møtte en mann som alltid utsatte det kjedelige. Til slutt bestod livet mest av ting han hadde utsatt.",
    "En kar skrudde meir enn han tenkte. Motoren fortalte det til heile kaia.",
    "Han som kunne innrømme feil først, kom som regel først heim.",
    "Det e rart ka folk lære når ingen ser på.",
    "Det e enda rarare kor fort de glømme det når naboen dukke opp.",
    "På kaia blir alle historia bedre med åra. Det e berre båtan som blir dårligare."
  ],
  "personal": [ // Personlige stikk (50)
    "Du treng ikkje ha alle svaran i dag. Det hold at du stille de riktige spørsmålan.",
    "Det e lett å tru at du e på villspor. Som regel e du berre litt utålmodig.",
    "Du bære meir enn folk ser. Pass på at du ikkje bære meir enn du må.",
    "Det e ikkje styrke å klare alt aleina. Det e berre tungt.",
    "Æ trur du har brukt mykje tid på ting som aldri ba om den.",
    "Det du grue dæ til, tenke sjelden like mykje på dæ som du trur.",
    "Du høre for mykje på uroa di og for lite på erfaringa di.",
    "Det e lov å snu. Havet gjør det to ganga i døgnet.",
    "Du kan ikkje styre vinden. Men du kan bestemme koss du fortøye.",
    "Det du ikkje fikk til i går, har ikkje nødvendigvis gitt opp dæ.",
    "Du treng ikkje bevise nåkka for folk som allerede har bestemt sæ.",
    "Den tyngste sekken e ofte full av forventninga du aldri ba om.",
    "Du har overlevd alle dårlige daga dine så langt. Det e verdt å huske.",
    "Det e forskjell på å gi opp og å velge ei klokare retning.",
    "Du e flinkare enn du trur til å finne feil hos dæ sjøl.",
    "Prøv å legg merke til det du faktisk får til også.",
    "Du treng ikkje spring så fort. Livet veit kor du bor.",
    "Det e mykje støy i verden. Ikkje alt fortjene oppmerksomheta di.",
    "Nån daga vinn du. Andre daga lære du.",
    "Det e berre stolte folk som trur læring e et nederlag.",
    "Du blir ikkje mindre verdifull fordi du e sliten.",
    "Det e lov å kvile før du fortsette.",
    "Du har sagt ja fleire ganga enn hjertet ditt egentlig meinte.",
    "Prøv et nei av og til. Det flyte overraskande godt.",
    "Du ser lenger enn du trur. Du stole berre ikkje alltid på blikket ditt.",
    "Det e ikkje alle kamper som fortjene kreftan dine.",
    "Du kan ikkje ro tilbake til i går. Det e like greit.",
    "Nån menneska e som motvind. Du blir sterkare av dem, men du treng ikkje oppsøke dem.",
    "Det blir lysare. Det har æ sett nok ganga til å tørre å love.",
    "Æ trur du tenke meir enn du treng. Det gjør sjøen aldri.",
    "Ikkje mål dæ sjøl mot folk som spring på en vei du aldri ville gått.",
    "Du treng ikkje vinne alle diskusjona. Fred smake ofte bedre.",
    "Det e nån som sette pris på dæ uten at de sei det høgt.",
    "Du har blitt sterkare enn du sjøl har oppdaga.",
    "Nån svar kjem først når du slutte å mase etter dem.",
    "Det du savne mest, e kanskje berre ro.",
    "Du e ikkje seint ute. Du e berre på din egen flo.",
    "Vær litt snill med dæ sjøl. Du ska tross alt leve med dæ heile livet.",
    "Æ trur du e strengare mot dæ sjøl enn folk rundt dæ e.",
    "Du har lov å være stolt uten å rope om det.",
    "Det e nån som blir glad når de ser dæ. Hugs det på tunge daga.",
    "Du e flink til å ta ansvar. Hugs å legg det fra dæ av og til.",
    "Det e ikkje sikkert du e på feil vei. Kanskje e det berre motbakke.",
    "Du treng ikkje fikse alle rundt dæ.",
    "Du har bært ting så lenge at du nesten har glømt at de e tunge.",
    "Du prøve å være sterk for alle. Kanskje e det på tide at nån e litt sterk for dæ.",
    "Du treng ikkje rekke alt før sola går ned.",
    "Du blir ikkje mindre modig av å være redd.",
    "Du har meir erfaring enn tvilen din har argument.",
    "Innerst inne veit du ofte svaret. Du håpe berre at Ottar skal si nåkka anna."
  ],
  "wisdom": [ // Visdomsord (50)
    "Havet har aldri hatt hastverk. Likevel kjem det alltid fram.",
    "Du blir ikkje klok av å snakke mest. Du blir klok av å høre etter.",
    "Den som tåle stillheta, tåle som regel livet også.",
    "Et godt tau blir til av mange tråda. Det gjør gode menneska også.",
    "Storma vise dæ ikkje berre havet. De vise dæ folk.",
    "Det e lett å være modig når det e blikkstille.",
    "Du finn sjelden roa med å spring fortare.",
    "Folk som skylde på vinden, lære lite av stormen.",
    "Du kan pusse rust. Men det e betre å finne årsaka.",
    "Den tyngste lasten e sjelden den folk ser.",
    "Ei ærlig unnskyldning veie mindre enn ei løgn. Men ho bære lenger.",
    "Det e ikkje alt du kan reparere. Men du kan alltid fortøye bedre.",
    "Ingen blir sterk av medvind aleina.",
    "Det e forskjell på å være sta og å stå støtt.",
    "Du treng ikkje forstå alt for å vise respekt.",
    "Den som ler av andre kvar dag, har ofte lite å le av aleina.",
    "Kaia huske fleire historia enn folk gjør.",
    "En gammal båt knirka ikkje for å klage. Han minna berre folk på alderen sin.",
    "Stillheta har redda fleire vennskap enn raske svar.",
    "Du ser karakteren til folk når planen deira går i stykker.",
    "Det e billig å love. Det e dyrt å holde ord.",
    "Den som alltid ska ha siste ord, høre sjelden det viktigaste.",
    "Du kan ikkje fiske i går. Og du kan ikkje leve i går heller.",
    "Mange leite etter lykka. Få legg merke til at ho allerede sit ved sida av dem.",
    "Vinden bryr sæ ikkje om meiningan dine.",
    "Du blir ikkje rik av å spare på vennlighet.",
    "Et lite lys e nok når natta e mørk.",
    "Den som tør å snu, kjem ofte lenger enn den som nekta.",
    "Sjøen e stor nok til både stolthet og ydmykhet. Det burde vi også være.",
    "Livet rope sjelden. Det nikka berre.",
    "Det e ikkje den sterkaste vinden som velte båten. Det e den du ikkje tok på alvor.",
    "Den som lære sæ å vente, finn ofte meir enn den som spring.",
    "Du treng ikkje eie mykje for å mangle lite.",
    "De beste avgjørelsan blir sjelden tatt mens folk rope.",
    "Havet har aldri vært imponert over status.",
    "Det e lettere å holde kurs enn å finne den på nytt.",
    "Ei hand som hjelpe, huskes lenger enn ei munn som skryte.",
    "Mange leite etter store svar. Livet spør som regel om små ting.",
    "Du kan ikkje kjøpe erfaring. Du betale med tid.",
    "Den som alltid ser bakover, går lett på skjær.",
    "Du kan måle mykje. Men ikkje verdien av ei rolig natt.",
    "Det e ikkje alt som skal repareres. Nåkka skal berre tilgis.",
    "Et menneske blir ikkje større av at andre blir mindre.",
    "Du veit at du e hjemme når stillheta kjennes kjent.",
    "Det e bedre med få ord som blir huska enn mange som blir glemt.",
    "Ei klok avgjørelse lage sjelden mykje lyd.",
    "Det du vanne, det veks. Det gjeld både uro og håp.",
    "Stillheta har aldri løyet for mæ.",
    "Rust skynde sæ aldri.",
    "Det meste ordne sæ. Men sjelden på første forsøk."
  ],
  "endings": [ // Avslutninger (50)
    "Jaja. Du får no prøv.",
    "Ikkje kom og sei æ ikkje sa ifra.",
    "Resten får havet ordne.",
    "Kaffen blir ikkje varm av sæ sjøl.",
    "Gå no.",
    "Æ har sagt mitt.",
    "Det e ditt problem no.",
    "Ta med dæ vettet denne gangen.",
    "Husk redningsvesten.",
    "Og litt ydmykhet.",
    "Ring mora di.",
    "Ikkje ring Ronny.",
    "Ronny har gjort nok skade.",
    "Ta en kaffe før du bestemme dæ.",
    "Søvn først. Avgjørelse etterpå.",
    "Vent til i morra om du kan.",
    "Skynd dæ sakte.",
    "Hold dæ på land om du e usikker.",
    "Hør på den eldste i rommet.",
    "Om det ikkje e Ronny.",
    "Pust no litt.",
    "Det blir som det blir.",
    "Men hjelp gjerne litt til.",
    "Snu mens du fortsatt kan.",
    "Det e lov.",
    "Spar litt krefter til seinare.",
    "Ikkje bruk alle patronan på første måsa.",
    "Husk at havet ikkje har dårlig hukommelse.",
    "Du får den dagen du fortjene.",
    "Prøv å fortjen en god en.",
    "Ta det rolig med sjøltilliten.",
    "Den klare sæ fint uten meir næring.",
    "Ha respekt for været.",
    "Og for folk som veit meir enn dæ.",
    "Drikk vann innimellom.",
    "Kaffe telle ikkje.",
    "Det her går sikkert bra.",
    "Men æ ville ikkje vedda.",
    "Hold tauan stram.",
    "Og kjeften litt lausare.",
    "Smil om du må.",
    "Men ikkje til Skatteetaten.",
    "Kom heim før mørket.",
    "Det e enklare sånn.",
    "Lær litt i dag.",
    "Du treng det.",
    "Gjer mindre dumt.",
    "Det e et oppnåelig mål.",
    "Vi får sjå.",
    "Havet har siste ord."
  ],
  "ronny": [ // Ronny (50)
    "Ronny kjenne en kar.",
    "Det e aldri den karen du treng.",
    "Ronny har et godt tilbud.",
    "Ronny sine tilbud ende som regel med kvitteringa di.",
    "Ronny sa det va gratis.",
    "Det va før fakturan kom.",
    "Ronny lova at det berre tok fem minutt.",
    "Han sa ikkje ka dag.",
    "Ronny har aldri lest ei bruksanvisning frivillig.",
    "Han kalle det intuisjon.",
    "Ronny kjøpte verktøy før han visste ka som va ødelagt.",
    "Det e veldig Ronny.",
    "Ronny sa \"hold ølet mitt\".",
    "Det burde ingen gjort.",
    "Ronny veit alltid en snarvei.",
    "Den e som regel lengre.",
    "Ronny har aldri møtt et prosjekt han ikkje kunne undervurdere.",
    "Prosjektan føle det samme om Ronny.",
    "Ronny låne ting.",
    "Han huske berre halvparten.",
    "Ronny trur alt kan fikses med strips.",
    "Stripsan e lei av Ronny.",
    "Ronny smile når han sei \"det ordne sæ\".",
    "Det e då du burde gå.",
    "Ronny kjøpte billig.",
    "Ronny kjøpte dyrt etterpå.",
    "Ronny meinte været såg stabilt ut.",
    "Været svarte med hagl.",
    "Ronny skulle berre prøve litt.",
    "Litt blei mykje.",
    "Ronny sa \"æ har kontroll.\"",
    "Ingen blei roligare.",
    "Ronny kjenne en elektrikar.",
    "Elektrikaren kjenne ikkje Ronny.",
    "Ronny skulle spare pengar.",
    "Det kosta meir enn planlagt.",
    "Ronny tok med feil nøkkel.",
    "Som vanlig.",
    "Ronny trur garanti betyr lykke til.",
    "Butikken e uenig.",
    "Ronny skrur først.",
    "Tenke etterpå.",
    "Ronny har aldri angra tidsnok.",
    "Han jobbe fortsatt med den delen.",
    "Ronny ringe alltid når du endelig har fri.",
    "Han starta samtalen med \"berre et lite spørsmål.\"",
    "Det e aldri et lite spørsmål.",
    "Når Ronny dukke opp, blir dagen lengre.",
    "Når Ronny forsvinn, begynne oppryddinga.",
    "Om Ronny sei \"stol på mæ\", så stol heller på været."
  ],
  "skatteetaten": [ // Skatteetaten (50)
    "Skatteetaten søv aldri.",
    "De berre bytte kaffevakt.",
    "Skatteetaten veit meir om dæ enn naboen.",
    "Det e kanskje like greit.",
    "Når Skatteetaten smile, bør du lese det med liten skrift.",
    "Brev fra Skatteetaten blir aldri mindre av å ligge.",
    "Dei har god tid.",
    "Det har ikkje du.",
    "Skatteetaten glømme ingen.",
    "Berre betalingsfristen.",
    "Du kan gjømme kvitteringa.",
    "Men ikkje konsekvensan.",
    "Skatteetaten rope aldri.",
    "Dei sende berre eit nytt brev.",
    "Det e stillare.",
    "Men mykje dyrare.",
    "Ein kar sa han skulle ordne det seinare.",
    "Skatteetaten va enig.",
    "Seinare kom.",
    "Med renter.",
    "Det e forskjell på optimisme og bokføring.",
    "Skatteetaten ser forskjellen.",
    "Dei e glad i tal.",
    "Unnskyldninga står lenger ned på lista.",
    "Når du sei \"det ordne sæ\", skriv Skatteetaten \"påminnelse\".",
    "Dei har sitt eige språk.",
    "Det e overraskande forståelig.",
    "Når brevet blir tjukkare, blir smilet tynnare.",
    "Skatteetaten har aldri blitt imponert av forklaringa di.",
    "Dei har høyrt den før.",
    "Ei kvittering e billig.",
    "Ei manglande kvittering blir fort dyr.",
    "Det e lett å glømme papir.",
    "Papiran glømme sjelden dæ.",
    "Skatteetaten kjem sjelden uventa.",
    "Folk berre håpe det.",
    "Ein god perm gir betre søvn.",
    "Det gjer ikkje uåpna post.",
    "Skatteetaten e som floa.",
    "Ho kjem sjølv om du ikkje ser etter.",
    "Det e ingen skam å spørre ein rekneskapsførar.",
    "Det e billigare enn stolthet.",
    "Når talan ikkje stemme, begynne historiene.",
    "Historiene imponere ingen.",
    "Det e betre å betale ein gong.",
    "Enn å forklare tre gonga.",
    "Skatteetaten fiske ikkje.",
    "Men dei får ofte napp.",
    "Opne brevet.",
    "Før brevet opne dagen din."
  ],
  "gulls": [ // Måsan (50)
    "Måsan veit før folk veit.",
    "De berre skryt mindre av det.",
    "Ei måse flaug baklengs i morges.",
    "Det gjorde mæ urolig.",
    "Måsan landa mot vinden.",
    "Folk gjorde ikkje.",
    "Ei måse stjal frokosten min.",
    "Ho hadde sikkert en grunn.",
    "Måsan krangle berre når det e nødvendig.",
    "Det kan menneskan lære litt av.",
    "Ei måse satt og såg på dæ.",
    "Ho virka skeptisk.",
    "Måsan flyg aldri med unødvendig bagasje.",
    "Det burde fleire prøve.",
    "Ei måse lo i dag.",
    "Æ håpe det ikkje va av dæ.",
    "Måsan flytte sæ før uværet.",
    "Folk vente på ei app.",
    "Ei måse treng ikkje værmelding.",
    "Ho har auge.",
    "Måsan bruke mindre tid på å klage enn folk.",
    "Men dei får meir gjort.",
    "Ei måse kan lukte dårlig vurderingsevne på fleire kilometer.",
    "I dag fekk ho mykje å jobbe med.",
    "Måsan stole aldri på blankt hav.",
    "Det burde ikkje du heller.",
    "Ei måse hakka på speilet i en bil.",
    "Ho trudde nok det va enda en idiot.",
    "Måsan e sjelden imponert.",
    "Det e sunt.",
    "Ei måse tok fisken før fiskaren såg den.",
    "Erfaring vinn ofte over fart.",
    "Måsan flyg lågt når folk blir overmodige.",
    "Det skjer oftare enn du trur.",
    "Ei måse såg på Ronny.",
    "Ho flaug vidare uten et ord.",
    "Det va nok.",
    "Måsan krangle høgt.",
    "Men dei blir fort ferdige.",
    "Folk burde notere det.",
    "Ei måse landa på båten min.",
    "Ho gjekk igjen med en gong ho såg Ronny.",
    "Måsan har aldri spurt om råd.",
    "Dei klare sæ godt likevel.",
    "Ei gammal måse e meir verd enn ti nye ekspertar.",
    "Ho har sett meir.",
    "Måsan gløyme aldri kor maten e.",
    "Eller kven som kasta stein.",
    "Får måsan ei dårlig magefølelse...",
    "...så burde du få det òg."
  ],
  "havet": [ // Havet (50)
    "Havet lyg aldri.",
    "Folk gjør det nok.",
    "Havet har sett smartere folk enn oss.",
    "Det har også sett dummare.",
    "Havet blir aldri sint.",
    "Det blir berre ferdig med dæ.",
    "Havet treng ikkje rope.",
    "Det vente.",
    "Havet gir alltid et varsel.",
    "Folk har det travelt.",
    "Havet huske alle feil.",
    "Berre ikkje alle samtidig.",
    "Havet bryr sæ ikkje om CV-en din.",
    "Det ser berre avgjørelsan.",
    "Havet like ikkje hastverk.",
    "Men det ser mykje av det.",
    "Havet har aldri lest ei bok.",
    "Likevel kan det meir enn mange professora.",
    "Havet belønne tålmodighet.",
    "Og straffe overmot.",
    "Havet veit når du late som.",
    "Det gjør folk òg.",
    "Havet kan være stille.",
    "Det betyr ikkje at det e enig.",
    "Havet gir.",
    "Havet tar.",
    "Havet forklare aldri koffør.",
    "Det e ikkje jobben dets.",
    "Havet teste alle.",
    "Nokon fleire gonga enn andre.",
    "Havet bryr sæ lite om unnskyldninga.",
    "Men det høre på handlinga.",
    "Havet har aldri hatt dårlig tid.",
    "Derfor vinn det alltid.",
    "Havet tilgir den forsiktige.",
    "Den hovmodige må ordne opp sjøl.",
    "Havet har ingen favoritta.",
    "Berre overlevende.",
    "Havet e gammelt.",
    "Derfor har det slutta å diskutere.",
    "Havet kan lære dæ alt.",
    "Om du klare å holde kjeft lenge nok.",
    "Havet e den einaste som alltid får siste ord.",
    "Resten av oss prøve berre.",
    "Havet veit kor liten du e.",
    "Det e sunt å bli minna på.",
    "Havet treng ikkje respekt.",
    "Men du treng å vise den.",
    "Hør på havet.",
    "Det har holdt på litt lenger enn dæ."
  ],
  "kaffe": [ // Kaffen (50)
    "Kaffen lyg aldri.",
    "Den blir berre kald.",
    "Første koppen e til kroppen.",
    "Den andre e til vettet.",
    "Den tredje redde dagen.",
    "Den fjerde redde andre folk.",
    "Æ stole meir på kaffen enn magefølelsen.",
    "Magefølelsen har skuffa mæ før.",
    "Kald kaffe e fortsatt bedre enn dårlig råd.",
    "Men ikkje med mykje.",
    "Kaffen smake annerledes når du veit du har gjort nåkka dumt.",
    "Det e derfor den blir sterk.",
    "Ingen god plan har starta med tom termos.",
    "Kaffen treng ikkje sukker.",
    "Berre fred.",
    "Folk som avbryt første kaffekoppen...",
    "...har ikkje forstått livet.",
    "Det e forskjell på å være våken.",
    "Og klar.",
    "Kaffen ordne berre det første.",
    "Æ har aldri angra på en kopp kaffe.",
    "Berre på samtalan som kom etterpå.",
    "Kaffen blir ikkje bedre av hastverk.",
    "Det blir ikkje avgjørelsan heller.",
    "Ein kopp kaffe kan utsette mange dumme idear.",
    "Det e derfor æ alltid tar to.",
    "Den som skynde sæ frå kaffen...",
    "...spring ofte rett inn i problem.",
    "Kaffen spør aldri koffør.",
    "Den berre møte opp.",
    "Ein tom kopp fortel mykje om dagen.",
    "Ein full kopp gir en ny sjanse.",
    "Kaffen blir best når stillheta får plass.",
    "Folk burde prøve det oftare.",
    "Ingen trenge sterke meininga før første kopp.",
    "Det e berre farlig.",
    "Kaffelukta har redda fleire morgena enn motivasjon.",
    "Der e æ ikkje i tvil.",
    "Ein god kaffe treng ikkje forklaring.",
    "Akkurat som godt selskap.",
    "Kaffen blir kald.",
    "Probleman vente fortsatt.",
    "Så drikk opp først.",
    "Verden har aldri blitt redda på tom mage.",
    "Eller uten kaffe.",
    "Kopp nummer fem betyr at dagen blir lang.",
    "Kopp nummer seks betyr at Ronny har ringt.",
    "Kopp nummer sju betyr at Skatteetaten også har ringt.",
    "Når kaffen smake ekstra godt...",
    "...bør du la resten av dagen være i fred."
  ],
  "kaia": [ // Kaia (50)
    "Kaia gløyme ingenting.",
    "Det gjør folk av og til.",
    "Alle kommer til kaia med en plan.",
    "De fleste reiser heim med en annen.",
    "På kaia ser du fort kven som har gjort dette før.",
    "Og kven som berre har sett video om det.",
    "Kaia huske alle.",
    "Sjøl dem som håpe den ikkje gjør det.",
    "Ein mann kan skjule mykje.",
    "Men ikkje måten han fortøye på.",
    "Kaia e full av gode råd.",
    "Dei beste blir sjelden sagt høgt.",
    "Den første som kjem til kaia...",
    "...har som regel minst å bevise.",
    "Det e lett å kjenne att overmot.",
    "Det går fortare enn diesel.",
    "På kaia låne folk tau.",
    "Dei kloke levere tilbake.",
    "Kaia har sett fleire unnskyldninga enn storma.",
    "Storman va meir overbevisande.",
    "Du treng ikkje rope på ei kai.",
    "Alle høre deg likevel.",
    "Kaia veit kven som kan arbeide.",
    "Resten veit det sjøl òg.",
    "Ein tom kai betyr ikkje at ingen følge med.",
    "Det e berre mindre støy.",
    "På kaia blir sannheta ofte sagt med kaffekoppen i handa.",
    "Og uten å se på dæ.",
    "Kaia har ingen hemmeligheta.",
    "Berre folk som trur dei har det.",
    "Den som hjelpe først...",
    "...blir huska lengst.",
    "Kaia har aldri brydd sæ om titla.",
    "Berre om du møte opp.",
    "Det e lett å bli populær på land.",
    "Prøv det på kaia.",
    "Kaia har sett fleire store ord enn store fangsta.",
    "Fangstan va meir imponerande.",
    "På kaia lærer du fort å høre forskjell på skryt og erfaring.",
    "Det tar omtrent eitt minutt.",
    "Ingen blir klok av å stå med hendene i lomma.",
    "Kaia har bevist det i mange år.",
    "Den som alltid kjem for seint...",
    "...får alltid høre det.",
    "Kaia e stille før sola.",
    "Det e då du lærer mest.",
    "Kaia glømme aldri ein god nabo.",
    "Eller ein dårlig fortøyning.",
    "Når kaia blir stille...",
    "...bør du høre ekstra godt etter."
  ],
  "soring": [ // Søringen (50)
    "Søringen såg på havet.",
    "Havet såg tilbake.",
    "Søringen sa det blåste litt.",
    "Måsene flaug heim.",
    "Søringen kom med nye sko.",
    "Kaia lot dem ikkje være nye lenge.",
    "Søringen spurte kor langt det va.",
    "Han fekk svar i timar.",
    "Søringen stolte på vær-appen.",
    "Ottar stolte på kneet sitt.",
    "Kneet vant igjen.",
    "Søringen sa \"det ordner seg.\"",
    "Han hadde ikkje møtt havet før.",
    "Søringen tok bilde av bølgene.",
    "Bølgene tok nesten resten.",
    "Søringen kalte det frisk bris.",
    "Fiskeran kalte det tirsdag.",
    "Søringen ville ha utsikt.",
    "Havet ga ham perspektiv.",
    "Søringen spurte om det var dypt.",
    "Havet svarte ikkje.",
    "Det trengte det ikkje.",
    "Søringen kjøpte dyr jakke.",
    "Regnet brydde seg lite.",
    "Søringen hadde med paraply.",
    "Vinden takka pent for gaven.",
    "Søringen sa \"det ser trygt ut.\"",
    "Ottar gikk heim.",
    "Søringen ville prøve sjøl.",
    "Det gjorde han berre én gang.",
    "Søringen mente tauet holdt.",
    "Tauet hadde ikkje stemmerett.",
    "Søringen sa \"vi rekker det.\"",
    "Tidevannet hadde en annen kalender.",
    "Søringen ville diskutere været.",
    "Været deltok ikkje.",
    "Søringen tok av redningsvesten.",
    "Ottar tok båten til land.",
    "Søringen spurte om det alltid var sånn.",
    "Ottar svarte \"nei.\"",
    "\"Av og til e det verre.\"",
    "Søringen sa \"Google sier...\"",
    "Havet hadde ingen kommentar.",
    "Søringen smilte før stormen.",
    "Stormen smilte sist.",
    "Søringen spurte om råd.",
    "Det va dagens beste avgjørelse.",
    "Ottar nikka.",
    "Søringen lærte.",
    "Då va han ikkje heilt søring lenger."
  ],
  "vaeret": [ // Været (50)
    "Vinden spør aldri om lov.",
    "Den berre kjem.",
    "Nordavinden bær aldri sladder.",
    "Berre sannheta.",
    "Regnet har redda mange frå dumme avgjørelsa.",
    "Dei skjønte det berre etterpå.",
    "Tåka skjule mykje.",
    "Mest folk sine feil.",
    "Det e lett å være modig i medvind.",
    "Vent til kulingen kjem.",
    "Været treng ikkje forklare sæ.",
    "Det e vi som må forstå.",
    "Når lufta blir for stille...",
    "...e det lurt å følge med.",
    "Stormen varsle alltid.",
    "Folk lytte sjelden.",
    "Ei sky kan lyge.",
    "Vinden gjør det aldri.",
    "Regnet vaske mykje.",
    "Men ikkje samvittigheita.",
    "Den første snøen avsløre alle som utsatte ting.",
    "Akkurat som kvart år.",
    "Solskin gjør folk overmodige.",
    "Det går fort over.",
    "Det finnes ikkje dårlig vær.",
    "Berre dårlege vurderinga.",
    "Tåka skjule ikkje faran.",
    "Ho skjule berre utsikta.",
    "Motvind bygge betre folk enn medvind.",
    "Men det tar lengre tid.",
    "Regnbuen kjem alltid etterpå.",
    "Derfor e den lett å like.",
    "Når vinden snur...",
    "...bør du kanskje det òg.",
    "Været bryr sæ lite om kalenderen.",
    "Det burde fleire gjere.",
    "Isen spør ikkje kor tung du e.",
    "Han berre svara.",
    "Hagl e naturens måte å avslutte diskusjonen på.",
    "Uten ord.",
    "Ein god dag begynne lenge før sola.",
    "Og sluttar ofte før vinden.",
    "Været har fleire meininga enn kommentarfeltet.",
    "Men betre argument.",
    "Høgt skydekke gir ofte lave forventninga.",
    "Det e ikkje dumt.",
    "Når fuglan blir stille...",
    "...blir æ oppmerksom.",
    "Hør på vinden.",
    "Han har vore her lenger enn alle ekspertan."
  ],
  "batmotor": [ // Båt & motor (50)
    "Ein motor fortel sannheta om du høre godt nok.",
    "Dei fleste skrur opp radioen.",
    "Motoren hosta i morges.",
    "Det gjorde bekymringan mine òg.",
    "Det som tikke i tomgang...",
    "...blir dyrt i fart.",
    "Ein god motor skryt aldri.",
    "Han berre går.",
    "Det e ikkje alle menneska som har lært det.",
    "Diesel lyge sjelden.",
    "Folk gjør det oftare.",
    "Ein propell tilgir lite.",
    "Men den lære fort.",
    "Motoren starta på første forsøk.",
    "Det gjorde mæ mistenksom.",
    "Alt som går for lett...",
    "...har ofte tenkt å ta igjen seinare.",
    "Ein laus bolt lage mykje støy.",
    "Litt som enkelte folk.",
    "Du kan polere båten.",
    "Men ikkje vedlikeholdet.",
    "Motorolje e billig.",
    "Ny motor e ikkje det.",
    "Det e lett å ignorere ein ulyd.",
    "Helt til den blir stillhet.",
    "Ein god skipper høre forskjell på lydan.",
    "Ein klok skipper reagere på dem.",
    "Tau og diesel luktar betre enn panikk.",
    "Det e æ sikker på.",
    "Motoren bryr sæ lite om sjøltillit.",
    "Han vil ha vedlikehold.",
    "Båten veit når du slurve.",
    "Han seie det berre seinare.",
    "Fortøyninga blir aldri viktig...",
    "...før vinden kjem.",
    "Ein båt utan anker e berre optimisme.",
    "Optimisme flyt ikkje langt.",
    "Ekoloddet vise botnen.",
    "Ikkje dømmekrafta.",
    "Det må du ordne sjøl.",
    "Ein full tank gir ikkje automatisk ein god tur.",
    "Men ein tom tank gir ofte ein kort ein.",
    "Du kan ikkje banne ein motor frisk.",
    "Mange har prøvd.",
    "Ein båt som knirka...",
    "...prøve berre å fortelle nåkka.",
    "Hør på lyden.",
    "Før lyden forsvinn.",
    "Ta vare på motoren.",
    "Han har redda fleire enn stoltheita nokon gong har."
  ],
  "livet": [ // Livet (50)
    "Livet rope sjelden.",
    "Det hoste litt først.",
    "Ein mann blir ikkje klok av å bli eldre.",
    "Han får berre fleire sjansa.",
    "Det tar eit heilt liv å forstå det en gammal mann meinte på eitt minutt.",
    "Dei fleste rekk det ikkje.",
    "Du eig lite her i verden.",
    "Du låne berre tida.",
    "Stolthet mette ingen.",
    "Men den har gjort mange svoltne.",
    "Dei beste historiene starta sjelden som gode idear.",
    "Det e derfor folk huske dem.",
    "Alle vil bli gamle.",
    "Ingen vil øve.",
    "Du lære meir av ein dårlig dag enn ti enkle.",
    "Om du tør å sjå etter.",
    "Livet har ingen reservehjul.",
    "Berre omveia.",
    "Det e lett å gi råd.",
    "Det e vanskelegare å leve etter dem.",
    "Alle trur dei har god tid.",
    "Helt til dei ikkje har det.",
    "Det e ikkje travelt før du gjer det travelt.",
    "Resten e berre klokke.",
    "Den som alltid må vinne...",
    "...tape ofte det viktigaste.",
    "Livet belønne sjelden hastverk.",
    "Men det straffe det ofte.",
    "Nokre døre bør stå lukka.",
    "Ikkje fordi du ikkje kan opne dem.",
    "Men fordi du ikkje treng.",
    "Folk huske korleis du fekk dem til å føle sæ.",
    "Ikkje kor flink du sa du va.",
    "Du får ikkje fleire daga.",
    "Berre færre igjen.",
    "Det e ingen tragedie.",
    "Det e berre sånn det e.",
    "Den som aldri ombestemme sæ...",
    "...har slutta å lære.",
    "Livet blir lettare når du slutte å konkurrere med alle.",
    "Soloppgangen spør aldri kor rik du e.",
    "Det burde sei deg nåkka.",
    "Ein god venn e billig heilt til du mangla ein.",
    "Då blir han uvurderlig.",
    "Du treng ikkje forstå alt.",
    "Berre det viktigaste.",
    "Når du ser tilbake...",
    "...blir mykje mindre viktig enn du trudde.",
    "Lev sånn at kaffen smake godt.",
    "Resten ordne sæ som regel."
  ],
  "faren": [ // Faren (20)
    "Far min sa aldri at han va stolt. Han møtte berre opp.",
    "Far min kunne høre uvær før radioen.",
    "Æ skjønte ikkje far min før æ blei eldre enn han va.",
    "Han lærte mæ å fortøye. Resten måtte æ lære sjøl.",
    "Far min stolte aldri på blank sjø. Det gjør ikkje æ heller.",
    "Han snakka lite. Derfor huske æ det han sa.",
    "Far min sa at ei dårlig knute alltid vente på vind.",
    "Han kasta aldri nåkka som kunne repareres.",
    "Far min meinte at nye støvla gjorde folk uforsiktige.",
    "Han va streng med tau og mild med folk.",
    "Far min kom alltid heim før været bestemte sæ.",
    "Han drakk kaffen svart og unnskyldte sæ aldri for det.",
    "Når far min blei stille, blei resten av båten det òg.",
    "Han sa du kunne måle en mann på ka han gjorde når ingen såg.",
    "Far min trudde ikkje på flaks. Men han takka den av og til.",
    "Han lærte mæ at redsel og respekt ikkje e det samme.",
    "Far min hadde hender som såg eldre ut enn resten av han.",
    "Han kunne reparere det meste. Utenom tida.",
    "Æ savne han mest når vinden kjem frå nord.",
    "Far min e borte. Rådan hans e det ikkje."
  ],
  "johannes": [ // Johannes (20)
    "Johannes sa alltid at havet betale tilbake. Han fikk rett.",
    "Den siste gangen æ såg Johannes, va det vindstille.",
    "Ingen fant støvlan. Det va det som va verst.",
    "Johannes lo aldri høgt. Men alle hørte når han gjorde det.",
    "Han kunne finne fisk der ekkoloddet ga opp.",
    "Johannes plystra aldri i tåka. Ingen spurte koffør.",
    "Han hadde et arr han aldri forklarte.",
    "Johannes sa at sjøen kjenne navnet på alle som går ut.",
    "Han lånte aldri bort kniven sin. Berre rådan.",
    "Det står fortsatt en kopp etter Johannes i naustet.",
    "Han meinte at en båt avsløre eieren sin etter første kuling.",
    "Johannes kom alltid først på kaia og sist i praten.",
    "Han såg stormen i horisonten før skyene gjorde det.",
    "Ingen slo Johannes i kort. Nån prøvde én gang.",
    "Han sa aldri farvel før han gikk ut.",
    "Etter Johannes forsvant, blei måsan stillere ei stund.",
    "Ronny påstår han kjenne sannheta. Det gjør han ikkje.",
    "Johannes hadde en klokke som alltid gikk sju minutt seint.",
    "Av og til høre æ stemmen hans i nordavinden.",
    "Havet tok Johannes. Historien beholdt han."
  ],
  "marta": [ // Marta på butikken (20)
    "Marta veit meir enn internett.",
    "Om Marta spør kordan det går, bør du svare ordentlig.",
    "Marta treng ikkje Facebook. Ho har butikk.",
    "Ho veit kem som e sjuk før legen.",
    "Marta ser forskjell på en kunde og en mann som gjømme sæ.",
    "Ho har aldri glømt en gjeld. Heller ikkje en god gjerning.",
    "Marta pakke brød som om været kjem.",
    "Når Marta sei «jaja», e saken avgjort.",
    "Ho veit kven som krangle før de sjøl veit det.",
    "Marta har hatt samme kaffekopp siden 1989.",
    "Ingen prute med Marta to ganga.",
    "Ho har nøkkel til tre hus ho ikkje eig.",
    "Marta sier lite om folk. Det e derfor alle lytte.",
    "Når strømmen går, fortsette butikken som før.",
    "Marta kjenne alle bursdaga og halvparten av hemmelighetan.",
    "Ho selge tau, melk og dårlige nyheter med samme ansikt.",
    "Ronny får aldri handle på krita. Marta har grenser.",
    "Marta veit når båten kjem inn før den vises.",
    "Ho spør aldri koffør du treng fyrstikka klokka seks om morgenen.",
    "Bygda hadde klart sæ uten internett. Ikkje uten Marta."
  ],
  "gamleSjarken": [ // Den gamle sjarken (20)
    "Den gamle sjarken knirka meir enn mæ.",
    "Han tok inn vatn. Akkurat nok.",
    "Æ solgte han. Det angra æ fortsatt litt på.",
    "Ingen nye båta luktar sånn.",
    "Motoren starta berre når han sjøl ville.",
    "Sjarken hadde fleire lappa enn originalt treverk.",
    "Han va aldri rask. Men han kom heim.",
    "Kompasset viste litt feil. Æ stolte meir på båten.",
    "Det va en sprekk i ruta som passa perfekt mot horisonten.",
    "Sjarken likte ikkje sørvest. Ingen av oss gjorde det.",
    "Han kjente leia bedre enn folk kjenne sin egen gate.",
    "Æ kunne høre humøret hans på tomgangen.",
    "Den gamle sjarken bar meir historie enn last.",
    "Bamse hadde sin plass ved døra. Ingen andre fikk den.",
    "En vinter frøs alt utenom motoren. Det va nok.",
    "Ronny prøvde å forbedre han. Det blei stoppa i tide.",
    "På stille daga hørtes hvert år i skroget.",
    "Han kom heim med berre én lanterne og mye verdighet.",
    "Ny e ikkje det samme som bedre.",
    "Av og til drømme æ at sjarken ligg ved kaia igjen."
  ],
  "stormen97": [ // Stormen i 97 (20)
    "Etter stormen i 97 slutta æ å diskutere med vinden.",
    "Æ mista meir enn garn den dagen.",
    "Ingen snakke mykje om den stormen.",
    "Havet huske. Det gjør æ òg.",
    "Radioen blei stille før det verste kom.",
    "Johannes sa vi skulle snu. For en gangs skyld gjorde alle det.",
    "Kaia låg lavere morgenen etter.",
    "Tre båta mangla. To kom tilbake.",
    "Marta holdt butikken åpen heile natta.",
    "Far min sitt gamle tau holdt. Det nye gjorde ikkje.",
    "Vinden tok taket på naustet og halve stoltheita vår.",
    "Ingen sov da sørvesten kom over fjellet.",
    "Bamse nekta å gå ut. Han va klokere enn oss.",
    "Æ har aldri hørt regn slå så hardt mot glass.",
    "Sjøen va kvit heilt inn til land.",
    "Ronny fortelle at han redda en båt. Båten huske det annerledes.",
    "Morgenen etter snakka folk lavt.",
    "Vi fant ei åre langt oppe på veien.",
    "Det tok tre daga før måsan kom tilbake.",
    "Stormen gikk over. Det gjør ikkje alt."
  ],
  "forsteKjarlighet": [ // Den første kjærligheten (20)
    "Ho likte ikkje lukta av diesel.",
    "Æ valgte sjøen. Det e ikkje sikkert det va riktig.",
    "Av og til tenke æ på ho. Mest når det regne.",
    "Ho flytta sørover. Æ blei.",
    "Ho skreiv brev med blått blekk.",
    "Æ svarte sjeldnere enn æ burde.",
    "Ho lo av den gamle jakka mi. Men ho frøs aldri.",
    "Vi dansa én gang. Det va nok til å huske.",
    "Ho sa æ va sta. Æ beviste det.",
    "Ingen av oss sa farvel ordentlig.",
    "Ho ville se verden. Æ meinte havet va stort nok.",
    "Æ har fortsatt et bilde æ ikkje ser på.",
    "Ho drakk kaffe med melk. Det va ikkje derfor det tok slutt.",
    "Når toget gikk, stod æ igjen med hendene i lomma.",
    "Æ trudde det kom en ny sjanse. Tida trudde nåkka anna.",
    "Marta nevne ho aldri. Det e en slags vennlighet.",
    "Ho sendte et kort fra Bergen. Uten returadresse.",
    "Enkelte valg blir ikkje feil. Berre dyre.",
    "Æ huske stemmen bedre enn ansiktet.",
    "Noen går sørover. Andre blir stående og se etter."
  ],
  "bamse": [ // Bamse (20)
    "Bamse hata måsan.",
    "Han stolte ikkje på folk med reine støvla.",
    "Han sov alltid med ett øye åpent.",
    "Det va den smartaste i båten.",
    "Bamse visste når været snudde før kneet mitt.",
    "Han knurra berre på folk som fortjente det.",
    "Ronny blei knurra på ofte.",
    "Bamse spiste fisk, men aldri fra fremmede.",
    "Han nekta å gå om bord når motoren hørtes feil ut.",
    "En gang fant han veien heim gjennom tåka.",
    "Han låg ved ovnen som om han betalte husleie.",
    "Bamse likte Marta. Det sa mykje om dem begge.",
    "Han jagde måsan til han blei gammel nok til å respektere dem.",
    "Ingen kunne lyge for Bamse.",
    "Han satt alltid nærmest døra når stormen kom.",
    "Bamse blei grå rundt snuten før æ merka at æ blei det.",
    "Han venta på kaia hver gang båten va ute uten han.",
    "Den siste vinteren gikk han saktere. Æ gjorde det samme.",
    "Æ begravde han der han kunne høre havet.",
    "Av og til ser æ etter han før æ går om bord."
  ],
  "mysterier": [ // Mysterier og gamle regler (20)
    "Det står fortsatt en tom stol på kaia. Ingen sett sæ der.",
    "Lyset i naustet blinke fortsatt. Ingen har strøm der.",
    "Klokka på brygga stoppa i 1987. Ingen har dratt den opp siden.",
    "Nån legg fortsatt fersk sei på steinen. Ingen veit kem.",
    "Kvar torsdag står det fersk kaffe på benken. Ingen har sett kem som sette den der.",
    "Ingen ska plystre mot tåka.",
    "Når ei måse lande aleina, e det nåkka på gang.",
    "Nordavinden bære gamle stemma.",
    "Den som rope mot havet, får svar. Berre ikkje med ord.",
    "Det e forskjell på mørke og havmørke.",
    "Fullmånen gjør ingen dummare. Den avsløre berre kem som allerede e det.",
    "Av og til går det fotspor ut på brygga uten at de kjem tilbake.",
    "En lanterne lyse ute i sundet på netter uten båta.",
    "Det banke tre ganga i skroget før enkelte storma.",
    "Ingen veit koffør Johannes sin kopp aldri samle støv.",
    "Marta låse alltid bakdøra to ganga når tåka kjem.",
    "Bamse knurra mot den tomme stolen. Berre én gang.",
    "Den gamle sjarken har blitt sett nord for fyret.",
    "Havet låne aldri. Det berre vente.",
    "Enkelte ting bør få være uforklart."
  ],
  "nakneFolelser": [ // Nakne følelser (20)
    "Æ savne lyda av folk som ikkje leve lenger.",
    "Kaia e blitt stillare.",
    "En dag slutta æ å skynde mæ. Ingen merka det utenom mæ.",
    "Det e rart ka man savne.",
    "Det e ikkje kroppen som blir gammal først.",
    "Æ huske fleire stemma enn ansikt no.",
    "Æ e ikkje redd døden. Berre å ikkje rekke kaffen først.",
    "Noen daga savne æ folk æ ikkje va snill nok med.",
    "Det finnes unnskyldninga som kjem for seint.",
    "Æ har beholdt ting fordi de lukta av nån.",
    "En tom stol kan ta mykje plass.",
    "Det va lettere å være ung før æ visste kor fort det gikk.",
    "Æ prate av og til med folk som ikkje e her.",
    "Ingen fortelle dæ ka den siste gangen blir.",
    "Æ trudde æ skulle huske meir. Æ huske det viktigste.",
    "Det e tungt å savne nån du va sint på.",
    "Av og til går æ til kaia utan grunn.",
    "Gamle menn gråte òg. Vi gjør det berre i dårlig vær.",
    "Æ har sagt «det går bra» fleire ganga enn det gjorde.",
    "Ta vare på dem mens stemmen fortsatt svara."
  ],
  "zodiacBanter": {
    "vaeren": [
        "Væren. Du spring før tanken har fått på sæ støvlan.",
        "Du e Væren. Det forklar fleire småskada.",
        "Æ har sett geita være meir tålmodig.",
        "Væren ja. Full fart og halv plan.",
        "Du spring så fort at vettet ikkje rekk etter.",
        "Det e imponerande på sin måte.",
        "Væren. Om døra e stengt, prøva du skuldra først.",
        "Du e lett å finne. Du lage mest lyd.",
        "Væren. Du spør om veien etter at du har kjørt forbi.",
        "Ingen kan beskylde dæ for å nøle.",
        "Væren. Du starte gjerne før klokka.",
        "Resten får spring etter.",
        "Du e typen som rope «æ har kontroll».",
        "Det e da æ blir nervøs.",
        "Væren. Eventyr først. Konsekvensa etterpå.",
        "Du har meir mot enn tålmodighet.",
        "Væren. Kart e mest pynt for dæ.",
        "Du finn fram på vilje aleina.",
        "Du like motvind.",
        "Det e gjensidig.",
        "Væren. Du ser hinder som forslag.",
        "Av og til fungerer det faktisk.",
        "Du e rask til å tilgi.",
        "Sæ sjøl, først og fremst.",
        "Væren. Hadde du vært båt, ville gassen alltid stått litt for langt fram.",
        "Du får ting til å skje.",
        "Av og til med vilje.",
        "Væren. Æ håpe bremsan dine e bedre enn planan.",
        "Du e ikkje redd for å prøve.",
        "Det e derfor du har så mange historia."
    ],
    "tyren": [
        "Tyren. Sta som ei rusta fortøyning.",
        "Du flytte ikkje meining før floa gjør det.",
        "Tyren ja. Du kalle det prinsipp. Andre kalle det stahet.",
        "Æ har møtt steina som va meir fleksibel.",
        "Du gir dæ ikkje. Heller ikkje når du burde.",
        "Tyren. Om du først sett dæ ned, blir du der.",
        "Sta folk e nyttige. Helt til de blir sjef.",
        "Du kan vente lenge. Men ikkje stille.",
        "Tyren. Ingen flytte på dæ utan gravemaskin.",
        "Du står støtt. Av og til litt for støtt.",
        "Tyren. Du har bestemt dæ før spørsmålet e ferdig.",
        "Det spare tid. Ikkje nødvendigvis problem.",
        "Du e lojal.",
        "Og vanskelig å snu.",
        "Tyren. Når du først sei ja, mein du det.",
        "Når du sei nei, kan vi like gjerne dra heim.",
        "Du bygge heller enn å skryte.",
        "Det like æ.",
        "Tyren. Du trur tålmodighet vinn alt.",
        "Som regel har du rett.",
        "Du bær nag lengre enn vinteren.",
        "Det e imponerande.",
        "Tyren. Folk trur du e rolig.",
        "De burde sjå dæ når kaffen e tom.",
        "Du like ting som vare.",
        "Det gjelde meiningan òg.",
        "Tyren. Om tauet held, ser du ingen grunn til å bytte det.",
        "Du stole meir på erfaring enn entusiasme.",
        "Det e sjelden dumt.",
        "Tyren. Æ håpe du aldri krangle med et ekko."
    ],
    "tvillingene": [
        "Tvillingan. To meininga før frokost.",
        "Æ håpe dokker e enige i dag.",
        "Du klare å diskutere med dæ sjøl.",
        "Tvillingan. Ingen kjede sæ i ditt selskap.",
        "To hoda. Samme rot.",
        "Du skifte meining fortere enn vinden.",
        "Tvillingan. Du har alltid en plan B. Og C.",
        "Det e travelt å være dæ.",
        "Du begynne én historie og avslutte en annen.",
        "Likevel får du folk til å høre etter.",
        "Tvillingan. Du svarer før du veit ka du blei spurt om.",
        "Av og til treff du.",
        "Du kan være enig med begge sida.",
        "Det e nesten mistenkelig.",
        "Tvillingan. Hadde du vært radio, ville du hatt to kanala samtidig.",
        "Det blir liv av sånt.",
        "Du snakke fort.",
        "Tankene dine spring enda fortere.",
        "Tvillingan. Du e aldri aleina.",
        "Du har jo dæ sjøl å diskutere med.",
        "Du skifte kurs midt i sundet.",
        "Og kalle det utforsking.",
        "Tvillingan. Du lover lite.",
        "Men fortelle mykje.",
        "Du har flere svar enn spørsmål.",
        "Det e ikkje alltid nyttig.",
        "Tvillingan. Ronny blir stille rundt dæ.",
        "Det e en prestasjon.",
        "Du e vanskelig å følge.",
        "Men umulig å kjede sæ med."
    ],
    "krepsen": [
        "Krepsen. Hardt skall, mjukt humør.",
        "Du går sidelengs rundt problema.",
        "Kreps ja. Du huske alt.",
        "Også ting du burde glemt.",
        "Du blir fornærma på elegante måta.",
        "Krepsen. Du treng litt meir sol.",
        "Du bær følelsa som andre bær fiskekassa.",
        "Kreps ja. Du kjem fram når du føle dæ trygg.",
        "Du later som ingenting.",
        "Men du har allerede merka alt.",
        "Krepsen. Du trekk dæ tilbake før du blir sår.",
        "Det spare smerte. Og nærhet.",
        "Du passe på alle.",
        "Og glemme ofte dæ sjøl.",
        "Krepsen. Hadde du vært båt, ville du alltid søkt le.",
        "Det e ikkje feigt. Bare klokt.",
        "Du tar ting personlig.",
        "Også været, av og til.",
        "Krepsen. Du treng et heim som andre treng kompass.",
        "Uten det blir du urolig.",
        "Du tilgir.",
        "Men arkiverer.",
        "Krepsen. Du ser hvem som fryser før de sier det.",
        "Det e en fin egenskap.",
        "Du skjule mjukheta godt.",
        "Men ikkje for godt.",
        "Krepsen. Du treng ikkje løse alle andres storma.",
        "Fortøy din egen båt først.",
        "Du e sterkere enn du ser ut.",
        "Det veit havet."
    ],
    "loeven": [
        "Løven. Du vil helst ha applaus før du begynne.",
        "Måsan la merke til dæ først.",
        "Løve? Litt mykje manke. Litt lite redningsvest.",
        "Du trur alle ser på dæ.",
        "Av og til stemme det.",
        "Løven. Speilet ditt jobbe overtid.",
        "Du e ikkje beskjeden.",
        "Det e heller ikkje sola.",
        "Løven. Du går inn som om rommet venta på dæ.",
        "Rommet gjorde ikkje alltid det.",
        "Du liker å lede.",
        "Sjøl når ingen har bedt om det.",
        "Løven. Hadde du vært båt, ville navnet vært større enn motoren.",
        "Det hadde sett flott ut.",
        "Du tåle kritikk.",
        "Så lenge den e ros.",
        "Løven. Du lyse opp.",
        "Og av og til blende du.",
        "Du e varm.",
        "Men du kan svi folk som står for nær.",
        "Løven. Du vil bli huska.",
        "Det blir du.",
        "Du går sjelden stille.",
        "Det gjør heller ikkje måsan.",
        "Løven. Du treng ikkje vinne kvart rom.",
        "Nån rom har berre kaffe.",
        "Du har mot.",
        "Og et ganske godt publikum i ditt eget hode.",
        "Løven. Vær stor.",
        "Men ikkje stå i veien for utsikten."
    ],
    "jomfruen": [
        "Jomfruen. Du rydde før gjestan kjem.",
        "Og etterpå òg.",
        "Du sortere bekymringan alfabetisk.",
        "Jomfruen. Perfekt finnes ikkje.",
        "Men du leite fortsatt.",
        "Du rette på ting ingen andre såg.",
        "Jomfruen. Du kunne organisert sjøen.",
        "Det hadde irritert tidevannet.",
        "Du ser feilen før helheta.",
        "Det e både gave og plage.",
        "Jomfruen. Hadde du vært båt, ville verktøykassa hatt innholdsfortegnelse.",
        "Æ respektere det.",
        "Du liker kontroll.",
        "Været bryr sæ lite om det.",
        "Jomfruen. Du planlegge pausan.",
        "Og glemme å ta dem.",
        "Du e grundig.",
        "Av og til heilt til poenget går over bord.",
        "Jomfruen. Du vasker koppen før kaffen e drukket.",
        "Det e unødvendig effektivt.",
        "Du legg merke til alt.",
        "Spesielt det som mangler.",
        "Jomfruen. Du treng ikkje fikse alle.",
        "Folk e ikkje motorer.",
        "Du gjør ting ordentlig.",
        "Det e sjeldnere enn folk tror.",
        "Jomfruen. Slipp litt rot inn.",
        "Det kan være liv der.",
        "Du e flink.",
        "Prøv å være fornøyd òg."
    ],
    "vekten": [
        "Vekten. Du tenke så lenge at været skifte.",
        "To sida av saka? Du finn seks.",
        "Vekten. Avgjørelsen kjem vel snart.",
        "Kanskje.",
        "Du veie alt.",
        "Til slutt blir det tungt.",
        "Vekten. Kaffen blei kald mens du bestemte dæ.",
        "Men du valgte rett kopp.",
        "Du vil at alle skal være fornøyd.",
        "Det blir de ikkje.",
        "Vekten. Hadde du vært kompass, ville nåla bedt om meir tid.",
        "Nord vente ikkje.",
        "Du e diplomatisk.",
        "Helt til du blir lei.",
        "Vekten. Du ser begge sida.",
        "Derfor står du ofte midt i.",
        "Du unngår konflikt.",
        "Konflikten har lagt merke til det.",
        "Vekten. Du liker balanse.",
        "Havet liker å teste den.",
        "Du kan prate folk ned.",
        "Men ikkje alltid dæ sjøl.",
        "Vekten. Bestem dæ før floa snur.",
        "Eller bli med den.",
        "Du har god smak.",
        "Det hjelper lite når du ikkje velger.",
        "Vekten. Ikkje alle valg e livsvalg.",
        "Nån ganger e det berre kaffe.",
        "Du lage ro.",
        "Så lenge ingen spør ka du vil."
    ],
    "skorpionen": [
        "Skorpionen. Du har brodd klar.",
        "Også når ingen spør.",
        "Du stirre som om du allerede veit svaret.",
        "Skorpion. Folk bør ikkje lyge til dæ.",
        "Du oppdage det uansett.",
        "Litt mindre mistenksomhet hadde spart dæ tid.",
        "Skorpionen. Kaffen e trygg. Slapp av.",
        "I dag e ingen ute etter dæ.",
        "Du glemmer ikkje.",
        "Det gjør enkelte nervøse.",
        "Skorpionen. Hadde du vært båt, ville ingen visst ka som lå i lasterommet.",
        "Det ville vært låst.",
        "Du føler djupt.",
        "Og viser grunt.",
        "Skorpionen. Når du først stole på nån, mein du det.",
        "Når du slutte, e det ferdig.",
        "Du tåle mørke.",
        "Det e ikkje det samme som at du må bo der.",
        "Skorpionen. Du ser gjennom folk.",
        "Prøv å ikkje se hull på dem.",
        "Du e lojal.",
        "Men kvitteringa må stemme.",
        "Skorpionen. Brodd e nyttig.",
        "Men ikkje til å røre kaffen med.",
        "Du passe på det som e ditt.",
        "Av og til litt for hardt.",
        "Skorpionen. Du treng ikkje vinne i det stille.",
        "Nån ganger kan du berre snakke.",
        "Du e intens.",
        "Det e fint i små doser."
    ],
    "skytten": [
        "Skytten. Du sikte høgt.",
        "Kartet e meir et forslag.",
        "Du reise gjerne før du pakke.",
        "Skytten. Du finn veien.",
        "Etter nok omveia.",
        "Du har fleire plana enn sokka.",
        "Skytten. Eventyr e fint.",
        "Husk matpakka.",
        "Du sier ja før du veit til ka.",
        "Det holder livet i gang.",
        "Skytten. Hadde du vært båt, ville du alltid hatt kurs ut fjorden.",
        "Heimveien fikk ordne sæ.",
        "Du liker frihet.",
        "Og hater instruksjoner.",
        "Skytten. Du lover å komme tilbake.",
        "Men sier sjelden når.",
        "Du ser muligheter.",
        "Og går forbi varselskiltan.",
        "Skytten. Du ler av faren.",
        "Faren ler ikkje alltid tilbake.",
        "Du e ærlig.",
        "Av og til før folk e klare.",
        "Skytten. Du treff målet.",
        "Om målet står lenge nok.",
        "Du treng horisont.",
        "Ellers begynne du å flytte møblan.",
        "Skytten. Eventyrlyst e bra.",
        "Redningsvest e bedre.",
        "Du kjem langt.",
        "Spørsmålet e berre kor."
    ],
    "steinbukken": [
        "Steinbukken. Du klatre sjøl om ingen ser.",
        "Du gir dæ ikkje.",
        "Heller ikkje når knean ber om pause.",
        "Steinbukken. Du bygge før andre har bestemt sæ.",
        "Du e seigere enn gammalt tau.",
        "Det e et kompliment.",
        "Steinbukken. Litt kvile hadde ikkje skada.",
        "Men æ veit du ikkje høre etter.",
        "Du jobbe mens andre planlegge.",
        "Og planlegge mens andre kvile.",
        "Steinbukken. Hadde du vært båt, ville du gått i all slags vær.",
        "Og nekta service.",
        "Du stole på innsats.",
        "Det gjør banken òg.",
        "Steinbukken. Du bær ansvar som om det va ved.",
        "Legg ned litt før ryggen gjør det.",
        "Du e tålmodig.",
        "Men ikkje med tull.",
        "Steinbukken. Du gjør det som må gjøres.",
        "Og sukke så alle høre det.",
        "Du treng ikkje bevise alt.",
        "Fjell står stille utan applaus.",
        "Steinbukken. Du kommer fram.",
        "Sjøl om du velge den bratteste veien.",
        "Du bygger sakte.",
        "Det e derfor det står.",
        "Steinbukken. Hardt arbeid e fint.",
        "Men kaffe e òg arbeidshjelp.",
        "Du e pålitelig.",
        "Prøv å være tilgjengelig òg."
    ],
    "vannmannen": [
        "Vannmannen. Du finne på ting ingen ba om.",
        "Av og til e det genialt.",
        "Vannmannen. Du går dine egne veia.",
        "Ingen veit heilt kor de går.",
        "Du tenke litt annerledes.",
        "Det treng vi.",
        "Vannmannen. Havet like originale folk.",
        "Så lenge de kan svømme.",
        "Du svarer på spørsmål ingen har stilt.",
        "Av og til e svaret godt.",
        "Vannmannen. Hadde du vært båt, ville propellen vært på taket.",
        "Og det hadde sikkert virka.",
        "Du liker folk.",
        "På passende avstand.",
        "Vannmannen. Du ser framtida.",
        "Men glemmer nøklan.",
        "Du e fri i hodet.",
        "Av og til litt for fri.",
        "Vannmannen. Du forklarer ideen etter at du har bygd den.",
        "Det lage spenning.",
        "Du går mot strømmen.",
        "Sjøl når strømmen berre prøve å hjelpe.",
        "Vannmannen. Originalitet e fint.",
        "Men bruk standard skrue når det finnes.",
        "Du tenke stort.",
        "Og parkerer litt skjevt.",
        "Vannmannen. Verden treng nye tanker.",
        "Men gjerne med bruksanvisning.",
        "Du e annerledes.",
        "Det e heile poenget."
    ],
    "fiskene": [
        "Fiskene. Du kjenne strømmen før andre.",
        "Fisk ja. Du dagdrømme med kvalitet.",
        "Du bite på idea fortere enn sluk.",
        "Fiskene. Intuisjonen din e ofte først i rommet.",
        "Du føle mykje.",
        "Husk å tenke litt òg.",
        "Fiskene. Havet e på lag med dæ.",
        "I dag, i alle fall.",
        "Du svømme unna når det blir for høgt.",
        "Det e ofte klokt.",
        "Fiskene. Hadde du vært båt, ville du fulgt månen i stedet for kartet.",
        "Og kanskje kommet fram.",
        "Du merke stemninga.",
        "Før folk sjøl gjør det.",
        "Fiskene. Du drømme stort.",
        "Men fortøyninga må sjekkes likevel.",
        "Du e mjuk.",
        "Det betyr ikkje svak.",
        "Fiskene. Du ser det usagte.",
        "Av og til ser du litt for mykje.",
        "Du vil redde alle.",
        "Start med dæ sjøl.",
        "Fiskene. Du flyte med strømmen.",
        "Helt til du plutselig ikkje gjør det.",
        "Du har god intuisjon.",
        "Men den treng kaffe.",
        "Fiskene. Ikkje alt som glitre e et tegn.",
        "Nån ganger e det berre sild.",
        "Du høre havet.",
        "Prøv å høre folk òg."
    ]
},
  "stikk": [
    "Du ser ut som du stole litt for mykje på flaks.",
    "Du smile som om du nettopp gjorde nåkka dumt.",
    "Du tenke meir enn du lytte.",
    "Det e ikkje nødvendigvis en styrke.",
    "Du minne mæ om Ronny.",
    "Det va ikkje et kompliment.",
    "Du har for reine sko.",
    "Æ blir skeptisk av sånt.",
    "Du ser ut som en som kjøpe billig verktøy.",
    "Og dyr lærdom.",
    "Sjefa kjem og går.",
    "Kaffepausa består.",
    "Pass dæ for folk som bruke ordet synergi.",
    "Dei har sjelden med kaffe.",
    "Møtet kunne vært en e-post.",
    "Men da hadde ingen fått vaffel.",
    "Den som rope mest, har ofte minst peiling.",
    "Jobb e viktig.",
    "Men ikkje så viktig som folk trur.",
    "Du smile litt annerledes når du lyg.",
    "Det gjør alle.",
    "Ingen blir enklere av å bli forelska.",
    "Bare dummere.",
    "Kjærlighet tåle mykje.",
    "Stolthet tåle lite.",
    "Send meldinga.",
    "Eller la være.",
    "Men slutt å tenk på den.",
    "Hjertet har dårlig dekning.",
    "Penga går fortere enn båta.",
    "Spar litt.",
    "Ronny gjorde ikkje det.",
    "Det va underholdende.",
    "Tilbud e farlige når du ikkje treng nåkka.",
    "Lommeboka huske alt.",
    "Kontoen bryr sæ lite om optimismen din.",
    "Kvitteringa vinn alltid.",
    "Kjøp kvalitet.",
    "Du skal leve med det etterpå.",
    "Ingen veit heilt ka de driv med.",
    "Slapp av.",
    "Du e yngre enn du kjem til å være.",
    "Bruk det.",
    "Ikkje alt treng ei meining.",
    "Bare kaffe.",
    "Ring mora di.",
    "Ho blir glad.",
    "Sov meir.",
    "Internett vente.",
    "Ronny hadde samme planen.",
    "Han angra.",
    "Ronny kalte det investering.",
    "Banken kalte det nåkka anna.",
    "Ronny trudde YouTube va fagbrev.",
    "Det va det ikkje.",
    "Ronny kjøpte verktøy.",
    "Han mangla fortsatt evna.",
    "Ronny sa «kor vanskelig kan det være?»",
    "Svaret va «veldig».",
    "Sjøen har sett verre.",
    "Men ikkje mykje.",
    "Måsan følge med.",
    "Det burde du òg.",
    "Vinden har allerede bestemt sæ.",
    "Du ligg litt etter.",
    "Bølgan diskutere ikkje.",
    "Dei berre kjem.",
    "Fortøyninga e kjedelig.",
    "Helt til den ikkje e det.",
    "Du har mykje sjøltillit.",
    "Litt meir erfaring hadde hjelpt.",
    "Du ser ut som en som lese bruksanvisninga etterpå.",
    "Det e modig.",
    "Du treng ikkje vinne alt.",
    "Bare det viktigste.",
    "Hør mindre på eksperta.",
    "Litt meir på bestemor.",
    "Æ trur du klare det.",
    "Men ikkje på første forsøk.",
    "Du får ikkje tilbake tirsdagen.",
    "Så bruk han.",
    "Ingen kjem til å huske den krangelen.",
    "Bortsett fra dæ.",
    "Ting ordne sæ.",
    "Bare sjelden av sæ sjøl.",
    "Du e ikkje sein.",
    "Bare seinere enn planlagt.",
    "Kaffen blir kald.",
    "Det gjør humøret òg.",
    "Æ sa det samme i 1994.",
    "Ingen hørte.",
    "Æ har tatt feil før.",
    "To ganga, trur æ.",
    "Æ stole meir på måsan enn kommentarfelt.",
    "Det har fungert fint.",
    "Æ blir gammel.",
    "Det går overraskende bra.",
    "No har æ sagt nok.",
    "Resten får du finne ut sjøl.",
    "Du va nesten ferdig. Det e da feilene begynne."
],
  "sjeldne": [ // Sjeldne hendelser (50)
    "Ottar smilte. Ingen veit koffør.",
    "Ronny hadde faktisk rett. Det skjer ikkje igjen.",
    "Måsan blei heilt stille i tre minutt.",
    "Havet nikka.",
    "Kaffen blei kald før Ottar drakk den. Det har aldri skjedd før.",
    "Skatteetaten sendte et brev uten dårlig nytt. Ottar trur det e falskt.",
    "Ei måse leverte tilbake maten.",
    "Vinden snudde berre for å bevise et poeng.",
    "Ottar tok feil. Han nevne det aldri igjen.",
    "En søring fortøyde perfekt på første forsøk.",
    "I dag har havet ingen råd. Du må finne dem sjøl.",
    "Æ trur faktisk du klare det her.",
    "Du treng ikkje Ottar i dag.",
    "Den klokaste avgjørelsen e allerede tatt.",
    "Ingen advarsla i dag. Ikkje kast bort sjansen.",
    "I dag e det berre vind. Resten e opp til dæ.",
    "Havet ser ingen fare i dag.",
    "Måsan bryr sæ meir om fisken enn om dæ. Ta det som et kompliment.",
    "Du får ingen dom i dag. Lev litt.",
    "Stillheta e dagens svar.",
    "Ronny leverte tilbake det han lånte.",
    "Ronny møtte presis.",
    "Ronny leste bruksanvisninga.",
    "Ronny sa \"æ veit ikkje.\"",
    "Ronny kjøpte kvalitet først.",
    "Ronny svarte ikkje telefonen.",
    "Ronny innrømte feil.",
    "Ronny sa nei til et dårlig tilbud.",
    "Ronny hadde med riktig verktøy.",
    "Ingen trur på det.",
    "Tre måsa flaug baklengs.",
    "Fjæra kom uten lyd.",
    "Ein fisk hoppa opp og snudde.",
    "Sjøen låg heilt blank. For blank.",
    "Nordavinden tok fri.",
    "Regnet stoppa midt i ei sky.",
    "Tåka gjekk rundt kaia.",
    "Ingen bølga traff land på eit heilt minutt.",
    "Måsan såg mot fjellet.",
    "Havet venta.",
    "Æ savne gamle daga litt i dag.",
    "Æ skulle ønske far min hadde sagt det her tidligare.",
    "Du minne mæ om nån æ kjente.",
    "Det va ikkje den verste dagen i livet mitt. Berre den nest verste.",
    "I dag trur æ litt på flaks.",
    "Æ blei glad da æ såg sola. Sei det ikkje til nån.",
    "Av og til e det godt å komme heim.",
    "Ingen ska gå aleina i dag.",
    "Ta vare på dæ sjøl først.",
    "Nu går æ heim. Havet klare resten."
  ],
  "mytiske": [ // Mytiske hendelser (10)
    {"title": "DEN GYLDNE MÅSA", "text": "Ei gyllen måse landa på kaia. Ingen levande har sett det før."},
    {"title": "HAVET LO", "text": "Æ har hørt havet le. Det skremte mæ meir enn storm."},
    {"title": "EVIG KAFFE", "text": "Koppen blei aldri tom. Ingen veit ka det betyr."},
    {"title": "DEN TAPTE SJARKEN", "text": "Ei sjark som forsvant i 1974 la til kai i morges."},
    {"title": "OTTAR BA OM UNNSKYLDNING", "text": "Æ tok feil. Der. Nu har du sett nåkka ingen kjem til å tru på."},
    {"title": "JOHANNES KOM HEIM", "text": "Det stod våte støvla ved døra. Ingen hadde sett Johannes siden stormen."},
    {"title": "DEN TOMME STOLEN", "text": "Nån satt i den tomme stolen i natt. Kaia va våt rundt den."},
    {"title": "BAMSE BJEFFA", "text": "Æ hørte Bamse bjeffe ute på brygga. Han har vore borte i tjue år."},
    {"title": "NORDAVINDEN SA NAVNET DITT", "text": "Vinden sa navnet ditt. Æ ville holdt mæ nær land i dag."},
    {"title": "HAVET GA TILBAKE", "text": "I fjæra låg nåkka som forsvant før du blei født."}
  ]
};



// ---------------------------------------------------------------------------
// SEASON 3 + PREFIKSBIBLIOTEK
// prefixes: miljolinjer som legg seg FORAN hovudteksten. Dei star aldri aleine.
// ---------------------------------------------------------------------------
(() => {
  'use strict';
  const ADDITIONS = {
 "personal": [
  "Du blir ikkje svak av å si at det blei for mykje.",
  "Tida avslører meir enn forklaringa gjør.",
  "Du treng ikkje ha svaret i dag.",
  "Du blir berre lettere å finne.",
  "Nån ganga e uro berre kjærlighet uten arbeidsoppgave.",
  "Men du bør kjenne igjen spørsmålet.",
  "Det e lov å begynne på nytt.",
  "Men ikkje uten å rydde etter det gamle.",
  "Du kan savne nån og fortsatt holde døra lukka.",
  "Står ofte og vente når du kommer tilbake."
 ],
 "ronny": [
  "Ronny begynte alltid med «hør no her».",
  "Det betydde som regel at han ikkje hadde tenkt ferdig.",
  "Ronny sa det kom til å gå fort.",
  "Marta fant fram plaster før han va ferdig med setninga.",
  "Ronny hadde kjøpt nåkka på tilbud.",
  "Johannes spurte om han hadde kjøpt det han faktisk trengte.",
  "Ronny meinte han hadde funne en snarvei.",
  "Den tok resten av dagen og to ekstra tau.",
  "Ronny såg på problemet og smilte.",
  "Problemet tok det som et dårlig tegn.",
  "Ronny hadde med kaffe til alle.",
  "Det va den delen av planen ingen protesterte på.",
  "Ronny sa han hadde en enkel løsning.",
  "Enkel va den berre så lenge andre gjorde jobben.",
  "Ronny meinte erfaring va overvurdert.",
  "Johannes meinte det kom an på kem som mangla den.",
  "Ronny lånte et verktøy han ikkje visste navnet på.",
  "Han brukte det med en selvtillit verktøyet ikkje fortjente.",
  "Ronny kalte resultatet en læringsprosess.",
  "De andre kalte det tirsdag.",
  "Ronny såg muligheta der andre såg dårlig vær.",
  "Bamse såg etter en plass i le.",
  "Ronny målte én gang og saga med overbevisning.",
  "Johannes målte resten etterpå.",
  "Ronny meinte instruksjonen va mer veiledende enn nødvendig.",
  "Garantien meinte nåkka anna.",
  "Ronny kalte det midlertidig.",
  "På kaia betyr det ofte resten av levetida.",
  "Ronny sa han hadde gjort det før.",
  "Ingen huska at det hadde gått bra da heller.",
  "Ronny kom først når nåkka skulle startes.",
  "Han blei til det va trygt å gå nærmere.",
  "Ronny mente problemet va overdrevet.",
  "Problemet venta høflig til han va ferdig.",
  "Ronny hadde alltid en plan B.",
  "Plan B va som regel å hente Johannes.",
  "Ronny sa det mangla berre en liten justering.",
  "Den lille justeringa krevde tre mann og flo sjø.",
  "Ronny fant fram strips.",
  "Da visste alle at reparasjonen va blitt permanent.",
  "Ronny sa han hadde kontroll.",
  "Marta spurte om kontrollen visste det.",
  "Ronny ville spare tid.",
  "Det kosta resten av ettermiddagen.",
  "Ronny meinte alt kunne fikses med riktig innstilling.",
  "Johannes henta riktig fastnøkkel.",
  "Ronny sto med begge hendene i lomman.",
  "Det va første tegn på at han hadde tenkt å lede arbeidet.",
  "Ronny sa han hadde sett en video.",
  "Bamse flytta sæ i trygg avstand.",
  "Ronny fant en løsning som ingen andre hadde sett.",
  "Det va fordi de andre hadde sett konsekvensan.",
  "Ronny tok på sæ ansvaret.",
  "Han bar det lett så lenge andre tok verktøyet.",
  "Ronny kalte det en prototype.",
  "Kaia kalte det nåkka som burde fortøyes.",
  "Ronny meinte motstand va et tegn på framgang.",
  "Motoren va uenig.",
  "Ronny lovte at det ikkje skulle bli dyrt.",
  "Det va før han begynte.",
  "Ronny kom med gode nyheta.",
  "De va at han hadde funne ut ka som va galt.",
  "Ronny sa at ingen måtte få panikk.",
  "Det va første gang nån vurderte det.",
  "Ronny fikk det til til slutt.",
  "Ingen va heilt sikker på ka «det» hadde vært."
 ],
 "havet": [
  "Når havet blir stille,",
  "Det venter berre på neste forsøk.",
  "Den som ser lenge nok utover,",
  "Berre om du har gjort jobben.",
  "Havet har aldri ledd av nån som prøvde.",
  "Fortøyninga forteller resten.",
  "Når floa kommer,",
  "E det ikkje alltid fred som kommer.",
  "Havet lærer tålmodighet uten å forklare pensum.",
  "Det gir berre beskjed til dem som høre etter.",
  "Havet huske alle som trudde de hadde kontroll.",
  "Blir forskjellen på mot og dumskap tydelig.",
  "Havet bryr sæ ikkje om alderen din.",
  "Ute teller berre det du faktisk gjør."
 ],
 "kaia": [
  "Kaia huske støvla som ikkje står ved døra lenger.",
  "Plankan knirke fortsatt på samme plass.",
  "Kaia huske alle som sa de berre skulle bort ei stund.",
  "Nån kom tilbake med gråere hår.",
  "Kaia huske den første motoren som stilna for godt.",
  "Etterpå hørtes måsan høyere ut.",
  "Kaia huske når ferga gikk saktere.",
  "Folk rakk å vinke ordentlig.",
  "Kaia huske alle hender som har dratt i samme tau.",
  "Ingen av dem holdt aleina.",
  "Kaia huske den gamle telefonkiosken.",
  "Det va lettere å vente når man måtte bli ståanes.",
  "Kaia huske båta bedre enn registreringsnummeran.",
  "Navnan satt lenger i treverket.",
  "Kaia huske ungene som fiska mellom pålan.",
  "No e det deres unga som står der.",
  "Kaia huske lyden av trekassa mot plankan.",
  "Før alt fikk hjul og plast.",
  "Kaia huske da nyheter kom med båten.",
  "Det gjorde sladderen òg.",
  "Kaia huske dem som dro uten å si farvel.",
  "Sjøen gjorde det for dem.",
  "Kaia huske første gangen strømmen kom.",
  "Ingen stolte heilt på lyset.",
  "Kaia huske da radioen va den viktigste stemmen.",
  "Folk hørte etter før de svarte.",
  "Kaia huske vinteren isen la sæ tjukk.",
  "Alle blei gåanes litt meir forsiktig.",
  "Kaia huske den siste sjarken med tredekk.",
  "Han knirka som en gammel mann.",
  "Kaia huske da ingen hadde mobil.",
  "Folk møtte opp fordi de hadde sagt de skulle.",
  "Kaia huske alle som lærte å ro her.",
  "De fleste begynte skjevt.",
  "Kaia huske dem som stod og venta på lys rundt moloen.",
  "Nån venta lenger enn andre.",
  "Kaia huske den gamle butikken ved veien.",
  "Marta visste ka du mangla før du gjorde det.",
  "Kaia huske da snøen låg til mai.",
  "Ingen kalte det ekstremvær.",
  "Kaia huske alle gangene Ronny sa det kom til å gå bra.",
  "Overraskende mange ganga gjorde det det.",
  "Kaia huske Johannes før ryggen blei krokete.",
  "Blikket va det samme.",
  "Kaia huske Bamse som valgte plass etter kem som trengte han.",
  "Han tok sjelden feil.",
  "Kaia huske faren som alltid stod igjen sist.",
  "Nån måtte vite at alle va kommet inn.",
  "Kaia huske første kjærlighet bedre enn folk gjør.",
  "De satt på samme benk kvar kveld.",
  "Kaia huske alle som kom heim til jul.",
  "Og dem som ikkje gjorde det.",
  "Kaia huske stormen som tok halve nausttaket.",
  "Resten blei holdt nede av folk.",
  "Kaia huske den første TV-en i bygda.",
  "Det va fullt hus hos dem som hadde den.",
  "Kaia huske da folk sendte brev.",
  "Ordene måtte tåle ventetida.",
  "Kaia huske den siste melkebåten.",
  "Etterpå blei bygda litt lenger fra alt.",
  "Kaia huske unga som sprang barbeint.",
  "De samme folkan klage no på kald trekk.",
  "Kaia huske da man kjente alle motorlydan.",
  "Da visste man kem som mangla.",
  "Kaia huske gamle navn malt over med nye.",
  "Malingen skjule mindre enn folk trur.",
  "Kaia huske den første plastbåten.",
  "De gamle rista på hodet heilt til de kjøpte en sjøl.",
  "Kaia huske da måsan fikk mat og ikkje berre kjeft.",
  "De oppførte sæ ikkje bedre da heller.",
  "Kaia huske alle verktøy som blei lånt.",
  "Og nesten alle som aldri kom tilbake.",
  "Kaia huske da sola kom tilbake etter mørketida.",
  "Folk gikk litt rettere den dagen.",
  "Kaia huske de tomme plassan etter stormen.",
  "Ingen satte sæ der på lenge.",
  "Kaia huske sankthansbål som blei større enn planen.",
  "Johannes visste alltid kor bøtta sto.",
  "Kaia huske første gangen nån sa internett.",
  "Ronny trudde det va et nytt garn.",
  "Kaia huske da unga flytta sørover.",
  "Foreldran begynte å se meir på telefonen.",
  "Kaia huske når de samme unga kom tilbake.",
  "De snakka fortere og sov lenger.",
  "Kaia huske alle som prøvde å begynne på nytt.",
  "De fleste starta med kaffe.",
  "Kaia huske den gamle benken før den blei reparert.",
  "Folk satt like godt på den da.",
  "Kaia huske dem som aldri sa de va glad i stedet.",
  "De kom kvar dag.",
  "Kaia huske når et håndtrykk va nok.",
  "Det holdt fordi folk blei.",
  "Kaia huske alle små tjenesta ingen skreiv ned.",
  "Det va dem bygda sto på.",
  "Kaia huske meir enn den forteller.",
  "Ellers hadde ingen turt å komme tilbake.",
  "Æ huske da ferga kom inn i mørket med lysan på.",
  "Heile bygda visste kem som va om bord.",
  "Æ huske den gamle telefonkiosken ved butikken.",
  "Det lukta kald metall og venting.",
  "Æ huske da strømmen gikk midt i middagen.",
  "Marta tente lys før nån rakk å klage.",
  "Æ huske første gangen nån kom med mobiltelefon.",
  "Ronny trudde dekninga kom med båten.",
  "Æ huske vinteren snøen nådde opp til vinduan.",
  "Vi gravde oss ut og kalte det tirsdag.",
  "Æ huske da fiskemottaket va fullt før sola sto opp.",
  "Lukta satt i klærne og stoltheita i ryggen.",
  "Æ huske den siste kiosken som solgte kaffe i pappkrus.",
  "Den gamle koppen smakte fortsatt best.",
  "Æ huske første gangen fjernsynet samla halve bygda.",
  "Ingen turte hoste under værmeldinga.",
  "Æ huske da man måtte avtale besøket dagen før.",
  "Folk kom likevel uten å ringe.",
  "Æ huske den gamle brygga før rekkverket kom.",
  "Vi lærte fort kor kanten va.",
  "Æ huske da unga fiska sei med hyssing.",
  "Fangsten blei større kvar gang historia blei fortalt.",
  "Æ huske den første motoren faren lot mæ starte sjøl.",
  "Han sto nær nok til å gripe inn.",
  "Æ huske da julestjerna blei hengt opp i novemberstorm.",
  "Den hang skeivt til nyttår.",
  "Æ huske påskemorran med appelsin og våte votta.",
  "Ingen klagde før skia va tatt av.",
  "Æ huske sankthansbålet som nesten tok med sæ naustet.",
  "Johannes hadde bøtta klar.",
  "Æ huske da skreien kom og døgnet blei for kort.",
  "Folk sov med støvlan nær senga.",
  "Æ huske mørketida før alle husan fikk utelys.",
  "Man kjente folk på stegan.",
  "Æ huske første soldagen etter vinteren.",
  "Kaffen blei drukket ute sjøl om den frøs i koppen.",
  "Æ huske den gamle fergebilletten i brystlomma.",
  "Den blei brukt som bokmerke i årevis.",
  "Æ huske da bensinen blei fylt fra ei handpumpe.",
  "Ingen stolte på måleren.",
  "Æ huske den første plastbåten på kaia.",
  "De gamle lo til den starta i motvind.",
  "Æ huske da radioen sto på fra frokost til kveld.",
  "Stemman blei nesten familie.",
  "Æ huske den siste butikken som skrev på krita.",
  "Regninga va personlig.",
  "Æ huske når alle visste kem som eide hver sykkel.",
  "Det gjorde låsan overflødige.",
  "Æ huske da brød blei levert i trekassa.",
  "Måsan lærte ruta fort.",
  "Æ huske den første fryseboksen i huset.",
  "Marta fylte den før vi rakk å spørre.",
  "Æ huske da man sendte julekort til folk man møtte kvar dag.",
  "Håndskrifta va halve hilsninga.",
  "Æ huske den siste gangen bestefar tok båten ut.",
  "Han sa ikkje at det va siste.",
  "Æ huske da kvinnfolkan stod og venta med kaffe på mottaket.",
  "De visste bedre enn klokka når båtan kom.",
  "Æ huske det første bildet tatt med digitalkamera.",
  "Ingen stolte på at filmen ikkje skulle framkalles.",
  "Æ huske da ungdomman dro sørover med én koffert.",
  "Foreldran rydda aldri heilt rommet.",
  "Æ huske første gangen de kom heim med egne unga.",
  "Kaia kjente igjen latteren.",
  "Æ huske den gamle skolebussen som hosta i kulda.",
  "Den kom fram fordi alle venta.",
  "Æ huske da værmeldinga kom én gang om dagen.",
  "Resten måtte vi finne ut sjøl.",
  "Æ huske vinteren sjøen frøs innerst i bukta.",
  "Bamse gikk utpå og angra med en gang.",
  "Æ huske første gangen vi så nordlyset danse rett over moloen.",
  "Ingen sa nåkka før det va borte.",
  "Æ huske den siste båten med navn malt for hand.",
  "Bokstavan va skeive og heilt riktige.",
  "Æ huske da fiskekassene va av tre.",
  "De veide meir tom enn plastkassene gjør full.",
  "Æ huske lyden av støvla i gangen etter uvær.",
  "Da visste vi at folk va kommet inn.",
  "Æ huske da alle hadde nøkkel under matta.",
  "Tyven måtte nesten være tilreisende.",
  "Æ huske den første kaffetrakteren på bua.",
  "Johannes stolte meir på kjelen.",
  "Æ huske da ny asfalt kom til bygda.",
  "Folk gikk ut berre for å se på den.",
  "Æ huske gamlekaran som satt ytterst på benken.",
  "De sa lite og visste alt.",
  "Æ huske da søndagan va stillere enn været.",
  "Man kunne høre bestikk gjennom åpne vindu.",
  "Æ huske den første gangen nån flytta tilbake frivillig.",
  "Alle lot som de ikkje va overraska.",
  "Æ huske da et brev kunne endre heile uka.",
  "Ingen åpna det ståanes.",
  "Æ huske den gamle redningsskøyta som kom inn etter stormen.",
  "Folk klappa uten å ha avtalt det.",
  "Æ huske da vi trudde bygda skulle dø ut.",
  "Så kom det barnevogner på kaia igjen.",
  "Æ huske meir enn æ klarer å fortelle.",
  "Det viktigste ligg ofte mellom setningan.",
  "Ronny sa: 'Æ har en plan.'",
  "Marta svarte: 'Da finn æ fram plaster.'",
  "Johannes spurte: 'Har du målt?'",
  "Ronny svarte: 'Æ har sett på det.'",
  "Ronny spurte om Johannes stolte på han.",
  "Johannes svarte: 'I medvind.'",
  "Marta satte fram kaffe.",
  "Johannes sa: 'Da kan vi begynne å være uenig.'",
  "Ronny sa at han hadde kontroll.",
  "Bamse gikk ut.",
  "Johannes sa: 'Vinden snur.'",
  "Marta svarte: 'Da gjør vi det før den.'",
  "Ronny spurte kor hammeren va.",
  "Marta svarte: 'Der du la den forrige gang.'",
  "Marta sa: 'Har du spist?'",
  "Ronny svarte: 'Æ har tenkt på det.'",
  "Johannes såg på tauet.",
  "Ronny sa: 'Det holder sikkert.'",
  "Marta svarte: 'Sikkert e ikkje ei knute.'",
  "Johannes nikka.",
  "Ronny sa: 'Hør no her.'",
  "Bamse sukka.",
  "Johannes spurte om planen hadde en slutt.",
  "Ronny svarte at den hadde god stemning.",
  "Marta sa: 'Vi tar én ting av gangen.'",
  "Ronny spurte kem som hadde tid til det.",
  "Ronny kom inn våt.",
  "Marta sa: 'Du sa det ikkje regna.'",
  "Ronny svarte: 'Det regna ikkje da æ sa det.'",
  "Johannes fortsatte å drikke kaffe.",
  "Marta spurte Johannes om han va enig.",
  "Han svarte: 'Ikkje nok til å snakke.'",
  "Ronny sa at båten berre trengte litt kjærlighet.",
  "Johannes svarte: 'Og ny impeller.'",
  "Marta sa: 'No høre du etter.'",
  "Ronny svarte: 'Æ gjør alltid det etterpå.'",
  "Johannes spurte kem som hadde festet fenderen.",
  "Ronny såg på været.",
  "Ronny sa at han hadde kjøpt nåkka nyttig.",
  "Marta spurte om det fulgte kvittering med.",
  "Marta sa at middagen va klar.",
  "Ronny svarte at han berre skulle gjøre én ting først.",
  "Johannes sa: 'Da blir maten kald.'",
  "Marta svarte: 'Det veit æ.'",
  "Ronny spurte om Bamse ville være med.",
  "Bamse la hodet ned.",
  "Marta sa: 'Hunden har svart.'",
  "Johannes sa: 'Klok hund.'",
  "Ronny mente at alt kunne repareres.",
  "Johannes svarte: 'Ikkje tid.'",
  "Marta spurte koffør de sto ute i regnet.",
  "Ronny svarte: 'Det begynte som en kort prat.'",
  "Johannes sa: 'Den båten ligger for løst.'",
  "Ronny svarte: 'Den e frihetselskende.'",
  "Marta sa at Ronny måtte ringe tilbake.",
  "Ronny svarte at han hadde tenkt å huske det.",
  "Johannes spurte: 'Før eller etter du glemmer?'",
  "Ronny blei stille.",
  "Ronny sa at han berre lånte stolen.",
  "Marta svarte: 'Du bar den heim.'",
  "Marta spurte om nån ville ha meir kaffe.",
  "Johannes løfta koppen én centimeter.",
  "Ronny sa at det va vanskelig å lese Johannes.",
  "Marta svarte: 'Han e ikkje vanskelig. Han e kort.'",
  "Johannes sa: 'Vi venter.'",
  "Ronny svarte: 'På ka?'",
  "Marta sa: 'På at du blir ferdig.'",
  "Bamse la sæ til rette.",
  "Ronny spurte om nån hadde sett lua hans.",
  "Johannes pekte på hodet hans.",
  "Marta sa: 'I dag gjør vi ingenting dumt.'",
  "Ronny spurte om det gjaldt heile dagen.",
  "Johannes svarte: 'Begynn med formiddagen.'",
  "Marta satte over meir kaffe.",
  "Ronny sa at han hadde fått en idé i natt.",
  "Marta spurte om den hadde fått sove nok.",
  "Johannes sa at motoren hørtes feil ut.",
  "Ronny svarte at den berre va litt hes.",
  "Marta spurte om han hadde sjekka olja.",
  "Ronny svarte: 'Æ har tenkt på olja.'",
  "Johannes sa: 'Da mangler det berre handling.'",
  "Ronny fant fram peilepinnen.",
  "Ronny sa at han kunne forklare alt.",
  "Marta svarte: 'Gjør heller det du lovte.'",
  "Johannes sa at været blei verre.",
  "Ronny svarte at humøret va stabilt.",
  "Marta sa: 'Humør e ikkje redningsvest.'",
  "Bamse såg på Ronny.",
  "Ronny spurte om nån hadde trua.",
  "Johannes svarte: 'På ka?'",
  "Marta sa: 'Det e et rimelig spørsmål.'",
  "Ronny begynte forklaringa på nytt.",
  "Johannes sa: 'No går vi heim.'",
  "Ronny svarte: 'Æ va akkurat i gang.'",
  "Marta slukka lyset.",
  "Bamse reiste sæ.",
  "Når døra til bua står åpen,",
  "Folk sett sæ likevel.",
  "Det ligg gamle navn under malinga.",
  "Blir skuldrene lavere hos dem som venta.",
  "Plankan knirke på samme sted som før.",
  "Den spør berre om du har fortøyd.",
  "Kaia har sett folk dra med én koffert.",
  "Treverket glemmer mindre enn folk.",
  "Kaia veit kem som alltid går sist.",
  "Og komme tilbake med barnevogn."
 ],
 "vaeret": [
  "Når skyene legger sæ lavt,",
  "E det lite hjelp i å være optimist uten regnklær.",
  "Regnet hadde god tid.",
  "Så blei dagen et felles prosjekt.",
  "Tåka la sæ rundt moloen.",
  "Bamse fant plassen nærmest ovnen.",
  "Vinden snudde mens kaffen trakk.",
  "Ronny stolte på den heilt til han blei våt.",
  "Sørvesten tok tak i naustveggen.",
  "Folk fant fram både ull og gamle minner.",
  "Når sluddet går sidelengs,",
  "Ser man kem som har festa godt.",
  "Det begynte med en liten trekk.",
  "Da blei lyden viktigere enn utsikta.",
  "Nordavinden kom uten å banke på.",
  "Johannes stramma lua og avslutta diskusjonen.",
  "Frosten kom før folk va ferdige med høsten.",
  "Marta setter på meir kaffe.",
  "Det va den typen vær som finner glippa i jakka — med vinden rett inn fra nord.",
  "Så blei dagen et felles prosjekt — før neste byge."
 ],
 "batmotor": [
  "Ronny meinte lyden va normal.",
  "E håp en dårlig erstatning for olje.",
  "Johannes la øret nærmere maskinrommet.",
  "Ronny kalte det negativ innstilling.",
  "Johannes sa at vedlikehold begynner før feilen.",
  "Blir alle lydene inni hodet høyere.",
  "Motoren hosta før den starta.",
  "Ronny skrudde ned radioen.",
  "Marta spurte om de hadde sjekka drivstoffet.",
  "Johannes sa at den prøvde å fortelle nåkka.",
  "Det va en ny lyd under dørken — mens dieselen gikk ujevnt.",
  "Den berre venter på at folk skal høre etter — før motoren hosta igjen."
 ],
 "livet": [
  "Nån feil blir historier.",
  "Her ser vi at den òg blir.",
  "Det finnes stillhet som gir fred.",
  "Andre blir vaner vess man ikkje følger med.",
  "Man kan være takknemlig og lei sæ samtidig.",
  "En dag skal ikkje få skrive heile historia.",
  "Folk sier tida går.",
  "Det betyr ikkje alltid at man ga opp.",
  "Livet blir sjelden som planen.",
  "Har ofte berre blitt flink til å skjule behovet.",
  "Det e ikkje alle savn som skal løses.",
  "Andre skal man lære å la stå igjen."
 ],
 "faren": [
  "Når nån ba om hjelp,",
  "Han blei ståanes til alle va inne.",
  "Faren lot lyset stå på.",
  "Johannes visste at det va kjærlighet i praksis."
 ],
 "johannes": [
  "Johannes sa at havet aldri lova nåkka.",
  "Det va derfor han stolte meir på det enn på folk.",
  "Johannes såg på skyene før han svarte.",
  "Været hadde ofte bedre formuleringer enn han.",
  "Johannes meinte stillhet va et språk.",
  "De fleste hadde berre glemt grammatikken.",
  "Johannes sa at en mann kunne lyge med munnen.",
  "Men aldri med måten han fortøyde båten på.",
  "Johannes hadde sett mange dra i sinne.",
  "De fleste kom tilbake i dårligere vær.",
  "Johannes sa at frykt ikkje va feighet.",
  "Det va kroppen som prøvde å få være med i avgjørelsen.",
  "Johannes meinte ei dårlig natt kunne redde en god beslutning.",
  "Det va derfor han sjelden svarte etter midnatt.",
  "Johannes snakka lite om savn.",
  "Han lot heller blikket bli værende ute på fjorden.",
  "Johannes meinte mot ikkje va å være uten redsel.",
  "Det va å kjenne den igjen og gå likevel.",
  "Johannes hadde ingen tro på raske svar.",
  "De holdt sjelden lenger enn været.",
  "Johannes sa at gamle båta knirka fordi de huska.",
  "Ingen lo særlig høyt av det.",
  "Johannes meinte folk viste kem de va i motvind.",
  "Medvind gjorde alle til kapteina.",
  "Johannes sa at man ikkje kunne navigere etter stolthet.",
  "Den pekte alltid mot grunnere vann.",
  "Johannes hadde lært at sinne kom fort.",
  "Det va opprettinga som tok tid.",
  "Johannes sa at noen sår måtte få luft.",
  "Andre trengte berre at folk slutta å pirke.",
  "Johannes meinte et løfte va som ei fortøyning.",
  "Det måtte tåle meir enn fint vær.",
  "Johannes så aldri ned på folk som va redd.",
  "Han hadde sett for mange modige drukne.",
  "Johannes sa at det farligste på havet va hastverk.",
  "På land kalte folk det ofte ambisjon.",
  "Johannes sa at ingen blei klok av å vinne alle diskusjona.",
  "Man blei berre vanskeligere å være i rom med.",
  "Johannes hadde ikkje behov for siste ord.",
  "Han visste at sjøen tok det uansett.",
  "Johannes sa at anger hadde dårlig retningssans.",
  "Den fant alltid tilbake til samme kai.",
  "Johannes meinte folk burde lytte meir til det de unngikk.",
  "Der lå som regel den egentlige historia.",
  "Johannes sa at en god venn ikkje alltid kom med råd.",
  "Noen ganger kom han berre med tau.",
  "Johannes hadde sett folk bli borte uten å reise.",
  "Det va den typen fravær han frykta mest.",
  "Johannes meinte sorg ikkje måtte fikses.",
  "Den måtte få et sted å sitte.",
  "Johannes sa at sannheta sjelden trengte å rope.",
  "Det va løgna som måtte jobbe overtid.",
  "Johannes meinte et menneske kunne tåle mye.",
  "Det va usikkerheta som sleit mest.",
  "Johannes sa at man ikkje skulle utfordre havet for å bevise nåkka.",
  "Havet hadde ingen interesse av poenget.",
  "Johannes hadde lært å vente på rett øyeblikk.",
  "Det va ikkje det samme som å være redd.",
  "Johannes meinte tilgivelse ikkje va å glemme.",
  "Det va å slutte å la minnet styre skuta.",
  "Johannes sa at ensomhet kunne stå midt i et fullt rom.",
  "Han hadde møtt den flere ganga.",
  "Johannes meinte et godt liv ikkje va uten storm.",
  "Det va å vite kor man skulle søke ly.",
  "Johannes sa at noen avskjeda tok mange år.",
  "Munnen sa farvel lenge før hjertet gjorde det.",
  "Johannes hadde sett håp overleve dårligere forhold enn folk.",
  "Det va både trøstende og farlig.",
  "Johannes meinte man skulle være forsiktig med å love evig.",
  "Det holdt lenge å være der i morgen."
 ],
 "marta": [
  "Marta satte fram kaffe før nån rakk å spørre.",
  "Ho visste at folk snakka lettere med varme hender.",
  "Marta sa ikkje at ho va bekymra.",
  "Ho satte berre en ekstra kopp på bordet.",
  "Marta hørte hele historia uten å avbryte.",
  "Det va derfor folk fortalte ho resten også.",
  "Marta rydda plass uten å gjøre et nummer av det.",
  "Hos ho va det alltid rom for én til.",
  "Marta såg på Ronny og sukka.",
  "Det va den høflige versjonen av et nei.",
  "Marta kunne høre på stillheta ka folk ikkje sa.",
  "Det va en egenskap ho aldri skrøyt av.",
  "Marta meinte mat måtte komme før gode råd.",
  "Folk tok som regel bedre valg etter andre koppen.",
  "Marta la et pledd over skuldrene hans.",
  "Ho spurte ikkje om han frøs.",
  "Marta sa at det kom til å gå over.",
  "Ho sa aldri at det kom til å gå fort.",
  "Marta huska kem som likte ka i kaffen.",
  "Det va hennar måte å si at folk betydde nåkka.",
  "Marta lot Ronny snakke ferdig.",
  "Så gjorde ho det som faktisk måtte gjøres.",
  "Marta trengte ikkje heve stemmen.",
  "Folk hørte etter likevel.",
  "Marta satte kaffekanna ut på kaia.",
  "Ho visste at gamle historia trengte nytt selskap.",
  "Marta sa at alle måtte få lande.",
  "Det gjaldt både båta og folk.",
  "Marta kunne gjøre et rom roligere uten å si et ord.",
  "Det va derfor stillheta rundt ho aldri føltes tom.",
  "Marta lo sjelden høyest.",
  "Men ho lo alltid når det trengtes mest.",
  "Marta spurte ikkje kem som hadde skylda.",
  "Ho spurte ka som måtte gjøres no.",
  "Marta sa at folk måtte få være i fred.",
  "Så satte ho seg i nærheten.",
  "Marta visste når en historie va ferdig.",
  "Ho visste også når den berre hadde tatt pause.",
  "Marta meinte noen svar måtte få stå over natta.",
  "Morgenen gjorde ofte halvparten av jobben.",
  "Marta va den første som såg at nån mangla.",
  "Ho va også den siste som gjorde det pinlig.",
  "Marta delte brødet uten å telle skivan.",
  "På kaia va det sånn man målte tillit.",
  "Marta sa at sinne ofte va sorg med støvla på.",
  "Johannes nikka uten å se opp.",
  "Marta hadde ingen hast med å tilgi.",
  "Men ho lot heller ikkje bitterheta få fast plass.",
  "Marta hørte forskjell på dårlig humør og et tungt hjerte.",
  "Det va ikkje alle som kunne det.",
  "Marta sa at folk måtte få prøve sjøl.",
  "Ho sto likevel klar med håndkle.",
  "Marta blei ikkje imponert av store ord.",
  "Ho la meir merke til kem som blei igjen etterpå.",
  "Marta lot døra stå ulåst når været va verst.",
  "Ingen spurte om det va tilfeldig.",
  "Marta sa at et hjem ikkje va veggan.",
  "Det va kem som satte på kaffe når du kom.",
  "Marta visste at noen unnskyldninga kom for tidlig.",
  "Ho venta heller på handlinga.",
  "Marta sa at man ikkje kunne bære alt for folk.",
  "Men man kunne gå ved siden av.",
  "Marta tok vare på de små detaljan.",
  "Det va ofte der folk gjemte det viktigste.",
  "Marta sa at ensomhet ikkje alltid va å være aleina.",
  "Noen ganger va det å ikkje bli sett.",
  "Marta la merke til den tomme stolen.",
  "Ho nevnte den ikkje før nån andre gjorde det.",
  "Marta va varm uten å være naiv.",
  "Det va derfor rådan hennes holdt i dårlig vær.",
  "Marta kunne være stille lenge.",
  "Men aldri på en måte som fikk folk til å føle sæ aleina.",
  "Marta sa at det fantes daga man berre måtte komme sæ gjennom.",
  "Ho hadde allerede satt på kaffe."
 ],
 "bamse": [
  "Bamse la sæ på plassen til den som mangla.",
  "Ronny ødela overraskende mange av dem.",
  "Bamse løfta hodet da Ronny reiste sæ.",
  "Marta sa at uro òg kunne ha fire bein.",
  "Bamse likte best de dagan ingenting skjedde.",
  "Men våkna av lyden av ost.",
  "Når folk krangla høyt,",
  "Han hadde lært at nåkka kom til å skje.",
  "Johannes lot som han ikkje mata Bamse.",
  "Bamse fant dem før kaffen gjorde det.",
  "Når vinden snudde,",
  "Snuten hans visste det først."
 ],
 "winter": [
  "Vinteren kom inn fra havet.",
  "Folk bruker det bedre.",
  "I januar e lyset kort.",
  "Kaia visste kem som kom.",
  "Det knirka i snøen før soloppgang.",
  "Blir alle lyder litt nærmere.",
  "Når snøen legger sæ over kaia,",
  "Går Bamse som om han har dårlig samvittighet.",
  "Kulda fant sprekkene først.",
  "Fortøyningan svarte tilbake."
 ],
 "spring": [
  "Når båtan skal ut etter vinteren,",
  "Johannes sa at kalenderen endelig hadde fått rett.",
  "Når snøen slipper taket,",
  "Folk blei ståanes litt lenger ute.",
  "Den første tjelden kom tilbake.",
  "Kaia kjente året snu.",
  "Sola traff naustveggen igjen.",
  "Huset måtte få høre våren.",
  "Marta åpna vinduan.",
  "Ingen stolte heilt på den ennå.",
  "Våren begynte med drypp fra taket.",
  "Dukker både søppel og håp fram."
 ],
 "summer": [
  "Marta satte kaffekanna ute.",
  "De gamle historiene får nytt publikum.",
  "Når kveldslufta fortsatt e varm,",
  "Bamse fant likevel den som va aleina.",
  "Sommeren kom med åpne naustdører.",
  "Sjøl Johannes innrømte at dagen va fin.",
  "Når båtan ligger tett i gjestehavna,",
  "Kaia lærte nye navn.",
  "Kaia blei full av fremmede stemmer.",
  "Blir det vanskelig å gå heim tidlig."
 ],
 "autumn": [
  "Når den første løvskura traff kaia,",
  "Han visste at avskjeder kunne være sesong.",
  "Båtan blei tatt opp én etter én.",
  "Folk begynte å sjekke tauan oftere.",
  "Regnet blei meir tålmodig.",
  "Lyset måtte få hjelp.",
  "Marta fant fram de tykke gardinan.",
  "Han sa det med lue på."
 ],
 "morketid": [
  "Kaia kjente folk på stegan.",
  "Blir små lys store nok.",
  "Mørketida la sæ over bygda.",
  "Må man bruke det godt.",
  "Marta tente lykta tidlig.",
  "Han hadde refleksvest på.",
  "Når natta varer gjennom dagen,",
  "Ansikta kom seinere.",
  "Når dagslyset berre e en kort gjest,",
  "Han visste at sola fortsatt fantes.",
  "Johannes såg mot den lyse stripa i sør.",
  "Ingen trengte å si kem de venta på.",
  "Ronny sa han likte mørket.",
  "Blir selskap en egen varme."
 ],
 "midnattssol": [
  "Bamse fant ikkje ut når dagen va slutt.",
  "Ingen hadde et godt argument mot lyset.",
  "Klokka sa at folk burde gå heim.",
  "Han hadde glemt tida med vilje.",
  "Johannes satt ute med kald kaffe.",
  "Han sov når folk endelig satte sæ.",
  "Marta dro gardina for.",
  "Blir dårlige avgjørelser lettere å se."
 ],
 "skrei": [
  "Johannes kjente kvaliteten før kniven traff.",
  "Blir døgnet for kort.",
  "Kaia våkna før bygda.",
  "Folk gikk lettere når fangsten va på land.",
  "Marta pakka mat for lange daga.",
  "Ingen trengte kalender."
 ],
 "christmas": [
  "Når kirkeklokkan bar over fjorden,",
  "Blei heile bygda stille et lite øyeblikk.",
  "Ronny kom med et tre som va bredere enn døra.",
  "Marta sa at forma kunne diskuteres.",
  "Jula kom til kaia med lys i mørket.",
  "Ingen kommenterte at den va den samme som i fjor.",
  "Bamse la sæ under julebordet.",
  "Han våkna berre når ribba kom."
 ],
 "easter": [
  "Ronny meinte skaren bar.",
  "Det va nok til å kalle det tradisjon.",
  "Bamse fulgte skisporet så lenge det lukta mat.",
  "Han kom først fram til matpausen.",
  "Marta pakka appelsin og kaffe.",
  "Været hadde siste ord."
 ],
 "morning": [
  "Morran begynte før sola.",
  "Varmen kom først."
 ],
 "night": [
  "Natta la sæ over moloen.",
  "Nån måtte avslutte dagen ordentlig.",
  "Når siste lys blei slukka,",
  "Bamse trudde ikkje på han."
 ],
 "prefixes": [
  "Da lyset traff kaia.",
  "Da sola krøp over fjellet.",
  "Mens regnet fant takrenna.",
  "Mens vinden gikk mellom naustan.",
  "Da tåka slukte moloen.",
  "Da havet roa sæ litt.",
  "Mens skyan dreiv nordover.",
  "Da frostrøyken sto over kaffen.",
  "Mens regnet småprata mot ruta.",
  "Da snøen dempa alle lyda.",
  "Mens nordavinden drog i naustveggen.",
  "Da kveldssola fant naustveggen.",
  "Mens bølgan slo dovent.",
  "Da lyset blei mjukare.",
  "Mens månen hang over fjorden.",
  "Da vinden løya.",
  "Mens dønningan gikk tungt mot kaia.",
  "Da himmelen åpna sæ.",
  "Mens regnet tromma jamt mot kaia.",
  "Da kaffen akkurat va ferdig.",
  "Mens kaffekoppen fortsatt va varm.",
  "Da døra til bua gjekk opp.",
  "Mens ingen hadde det travelt.",
  "Da den første latteren kom.",
  "Mens radioen sto lavt.",
  "Da alle fant plassen sin.",
  "Mens kaffekjelen småkokte.",
  "Da ingen såg på klokka.",
  "Mens dagslyset fortsatt hang ute på fjorden.",
  "Da stolen skrapa mot golvet.",
  "Mens praten tok ei pause.",
  "Da praten stilna litt.",
  "Mens alle bare blei sittanes.",
  "Da kaffelukta fylte rommet.",
  "Mens veden knitra.",
  "Da koppen blei fylt på nytt.",
  "Mens ingen hadde dårlig tid.",
  "Da døra blei stående på gløtt.",
  "Mens lyset falt inn gjennom vinduet.",
  "Johannes svarte ikkje med en gang.",
  "Johannes tok av sæ lua.",
  "Johannes nikka nesten usynlig.",
  "Johannes venta før han svarte.",
  "Johannes kika ut på været først.",
  "Johannes snudde sæ mot havet.",
  "Johannes venta til de andre va ferdige.",
  "Johannes tok en slurk kaffe.",
  "Johannes såg ned før han løfta blikket.",
  "Johannes lot spørsmålet ligge litt.",
  "Johannes retta litt på stolen.",
  "Johannes drog jakka tettere.",
  "Johannes holdt kaffekoppen med begge hender.",
  "Johannes lot kaffen kjølne før han svarte.",
  "Marta satte over meir kaffe.",
  "Marta fant fram et ekstra krus.",
  "Marta la ved på ovnen.",
  "Marta tørka av bordet.",
  "Marta flytta stolen litt nærmere.",
  "Ronny fann ei løysing.",
  "Ronny smilte før han forklarte.",
  "Ronny hadde henta verktøykassa.",
  "Ronny meinte det kom til å gå fint.",
  "Bamse løfta hodet.",
  "Bamse flytta sæ litt nærmere.",
  "Bamse sukka fornøyd.",
  "Bamse åpna eitt øye.",
  "Bamse fann den varmeste plassen.",
  "Bamse løfta hodet da døra gjekk opp.",
  "Bamse reiste sæ motvillig.",
  "Bamse såg først på Marta.",
  "Bamse la hodet ned igjen.",
  "Da kaffekoppen laga den første ringen på bordet.",
  "Da veden tok fyr med et lite knepp.",
  "Mens kaffelukta fylte rommet.",
  "Mens det kom lys i naustet.",
  "Da vinden tok tak i lua.",
  "Mens støvlan sto på rekke.",
  "Da kaffekjelen begynte å synge.",
  "Mens måsan skreik over taket.",
  "Da første latter kom før første ord.",
  "Mens fleire koppa kom på bordet.",
  "Da kaffeskvetten traff benken.",
  "Da radioen kom klart gjennom.",
  "Mens lyset traff kaffekoppen.",
  "Da ingen sa nåkka med en gang.",
  "Mens frokosten tok god tid.",
  "Da den første bilen passerte.",
  "Mens vinden flytta på tauverket.",
  "Da sjølukta kom inn gjennom døra.",
  "Mens ei måse landa på pullerten.",
  "Da bølgan slo tre ganger mot brygga.",
  "Mens rekka fortsatt va kald.",
  "Da garnet hang til tørk.",
  "Mens fortøyninga gnog mot jernet.",
  "Da fjorden låg heilt blank.",
  "Mens diesellyden døydde bort.",
  "Da sjøen slo oppunder trappa.",
  "Mens båten gynget rolig i fortøyninga.",
  "Da tidevatnet snudde.",
  "Mens rekka dryppa saltvatn.",
  "Da brygga knirka under støvlan.",
  "Mens sjøen brøyt mot moloen.",
  "Da vinden tok i mastene.",
  "Mens tauverket blei stramt.",
  "Da sjøsprøyten traff støvlan.",
  "Mens dønningan gikk tungt inn mot land.",
  "Da første fortøyning blei kasta.",
  "Mens naustporten åpna sæ.",
  "Da kaia blei stille igjen.",
  "Johannes tørka brillan.",
  "Johannes flytta koppen litt.",
  "Johannes rynka panna litt.",
  "Johannes blei stående med hendene i lomman.",
  "Johannes venta til vindkastet va over.",
  "Johannes venta før han sa nåkka.",
  "Johannes lot kaffen bli kald.",
  "Johannes sa det så lavt at de andre måtte lytte.",
  "Johannes kikka ned på brygga.",
  "Johannes såg på tauverket.",
  "Johannes lot spørsmålet ligge.",
  "Johannes lot det bli stille.",
  "Johannes holdt blikket på fjorden.",
  "Marta fant fram ei skål.",
  "Marta satte koppen foran Johannes.",
  "Marta bretta sammen kjøkkenhandduken.",
  "Marta åpna vinduet litt.",
  "Marta såg at alle hadde fått.",
  "Marta fylte opp koppen.",
  "Marta fant fram ullsokkan.",
  "Marta lukka ovnsdøra.",
  "Marta lot de andre prate ferdig.",
  "Ronny kom bærende på ei kasse.",
  "Ronny fant fram drillen.",
  "Ronny smilte mot problemet.",
  "Ronny meinte det lot sæ ordne.",
  "Ronny lo før han prøvde.",
  "Ronny pekte mot naustet.",
  "Ronny henta stigen.",
  "Ronny åpna verktøykassa.",
  "Ronny meinte det ordna sæ.",
  "Bamse strakk fram labben.",
  "Bamse gjespa høyt.",
  "Bamse snuste mot døra.",
  "Bamse flytta ørene.",
  "Bamse fulgte etter Johannes.",
  "Bamse fann solflekken på golvet.",
  "Bamse la sæ tungt ned.",
  "Bamse kikka mot kjøkkenet.",
  "Bamse såg mot kjøkkenet da kaffelukta kom.",
  "Bamse sukka tungt og la hodet på labban.",
  "Da kaffelukta kom før de første stegan.",
  "Mens kaffekjelen begynte å synge.",
  "Da veden falt sammen i ovnen.",
  "Mens flammene tok nytt tak.",
  "Da døra smalt i nordavinden.",
  "Mens vinduet dugga.",
  "Da regndråpan traff sinktaket.",
  "Mens snøen la sæ på rekka.",
  "Da frosten fant vinduet.",
  "Mens isen knitra i fjæra.",
  "Da lyset traff kaffekanna.",
  "Mens skyggen flytta sæ over kaia.",
  "Da sola fant vinduet.",
  "Mens mørket tok over.",
  "Da månen speila sæ i fjorden.",
  "Mens stjernan kom én etter én.",
  "Da himmelen åpna sæ mot vest.",
  "Mens kveldslufta blei kaldere.",
  "Da sjøen blei sølvgrå.",
  "Mens dagen slapp taket.",
  "Da båten la press på tauet.",
  "Mens rekka tørka i sola.",
  "Da masta pep i vinden.",
  "Mens propellen dryppa saltvatn.",
  "Da motoren stilna heilt.",
  "Mens bølgene fant steinan.",
  "Da fortøyninga blei kasta.",
  "Mens garnet hang tungt.",
  "Da krabbeteinan sto på rekke.",
  "Mens brygga tok imot nye steg.",
  "Da diesel og sjø blanda sæ.",
  "Mens det kom liv i havna.",
  "Da første måsa landa.",
  "Mens siste båten forsvant rundt odden.",
  "Da pullerten blei blank av regn.",
  "Mens sjøsprøyten traff ansiktet.",
  "Da tauverket slo mot masta.",
  "Mens sjøen skifta farge.",
  "Da fjorden blei speil.",
  "Johannes stramma glidelåsen.",
  "Johannes flytta capsen bakover.",
  "Johannes la handa på rekka.",
  "Johannes blei stående uten hastverk.",
  "Johannes lot blikket følge båten.",
  "Johannes tok en ny slurk.",
  "Johannes sa navnet stille.",
  "Johannes lytta til motoren.",
  "Johannes la fra sæ koppen.",
  "Johannes kjente etter vinden.",
  "Johannes lot skuldrene synke.",
  "Johannes slapp pusten rolig.",
  "Johannes rakk ikkje å svare.",
  "Johannes smilte for sæ sjøl.",
  "Johannes snudde seg sakte.",
  "Marta fant fram kaffeboksen.",
  "Marta rista duken.",
  "Marta lukka døra forsiktig.",
  "Marta hengte opp vottan.",
  "Marta fant fram brødkniven.",
  "Marta satte fram syltetøyet.",
  "Marta tok av lokket.",
  "Marta fant den reine koppen.",
  "Marta fylte opp vedkorga.",
  "Marta tente stearinlyset.",
  "Marta lot radioen stå på.",
  "Marta såg at ingen mangla.",
  "Marta tok fram ullpleddet.",
  "Marta fant fram smørboksen.",
  "Marta lot kaffen trekke litt lenger.",
  "Ronny hadde med hengeren.",
  "Ronny hadde glømt målebåndet.",
  "Ronny pekte mot garasjen.",
  "Ronny slo ut med armene.",
  "Ronny hadde allerede skrudd løs første bolten.",
  "Ronny meinte det sikkert gjekk.",
  "Ronny fann en plankebit.",
  "Ronny henta tau.",
  "Ronny henta ei bøtte.",
  "Ronny lo av sin egen plan.",
  "Ronny ga seg aldri halvveis.",
  "Ronny satte i gang før alle kom.",
  "Ronny hadde funnet en omvei.",
  "Ronny såg berre løysinga.",
  "Bamse løfta det andre øret.",
  "Bamse snudde seg mot døra.",
  "Bamse strekte på frambeinan.",
  "Bamse fulgte lukta.",
  "Bamse snuste på støvlan.",
  "Bamse la haka på labban.",
  "Bamse venta ved døra.",
  "Bamse fant skyggen.",
  "Bamse slo halen i golvet.",
  "Bamse rista av sæ vatnet.",
  "Bamse blei liggende der han va.",
  "Bamse lukta at Marta kom.",
  "Bamse fulgte kaffelukta.",
  "Bamse sukka enda en gang.",
  "Bamse såg etter Ronny.",
  "Bamse fant den mjukeste matta.",
  "Bamse tok imot klappen.",
  "Bamse bestemte sæ for å bli inne.",
  "Bamse sovna igjen.",
  "Da vinden fant glipa i naustveggen.",
  "Mens sjøen fortsatt bar nattelyset.",
  "Da kaffekjelen begynte å murre.",
  "Mens ei sky la skygge over fjorden.",
  "Da den første måsa slo ned.",
  "Mens trekken fant dørsprekken.",
  "Da regnet traff oljehyra.",
  "Mens støvlan tørka ved ovnen.",
  "Da sola traff masta først.",
  "Mens bølgene holdt samme takta.",
  "Da fjorden låg urørlig.",
  "Mens lyset krøp oppover fjellsida.",
  "Da frosten fortsatt satt i brygga.",
  "Mens lufta smakte salt.",
  "Da snøen knirka under støvlan.",
  "Mens morgenen tok god tid.",
  "Da vinden roa sæ litt.",
  "Mens havet holdt på sitt.",
  "Da mørket fortsatt hang igjen.",
  "Mens dagen våkna sakte.",
  "Da ei måse skreik over kaia.",
  "Mens fortøyninga ga litt etter.",
  "Da garnkassene sto klare.",
  "Mens sjøvatnet slo mot steinan.",
  "Da propellen slutta å dryppe.",
  "Mens brygga tok imot enda eit steg.",
  "Da rekka blei varm av sola.",
  "Mens tauverket lå i ein haug.",
  "Da båten dreiv rolig i stampen.",
  "Mens moloen sto der som alltid.",
  "Da første kaffekoppen kom om bord.",
  "Mens motorlokket fortsatt va lunkent.",
  "Da havna fekk liv igjen.",
  "Mens krabbeteinan venta.",
  "Da fjorden låg blå og stille.",
  "Mens naustet lukta tjære.",
  "Da havet pusta tungt.",
  "Mens bølgene fann trappa.",
  "Da pullerten skinte av regn.",
  "Mens rekka fortsatt va sleip.",
  "Johannes tok lua litt lenger ned.",
  "Johannes såg utover uten å myse.",
  "Johannes lot vinden bestemme farta.",
  "Johannes flytta sæ eit halvt steg.",
  "Johannes lot kaffekoppen stå.",
  "Johannes strauk skjegget tankefullt.",
  "Johannes såg mot leia.",
  "Johannes venta på lyden av motor.",
  "Johannes lot stillheta få siste ord.",
  "Johannes snudde koppen mellom hendene.",
  "Johannes såg på skyan.",
  "Johannes drog pusten djupt.",
  "Johannes lot augan kvile på fjorden.",
  "Johannes sa ingenting ennå.",
  "Johannes stod som om han hadde all tid.",
  "Johannes kjente lukta av tang.",
  "Johannes rista sakte på hodet.",
  "Johannes høyrte meir enn han såg.",
  "Johannes lot blikket følge måsan.",
  "Johannes stod støtt.",
  "Marta bretta opp ermene.",
  "Marta satte fram ei skål til.",
  "Marta løfta kaffekanna.",
  "Marta la eit vedtre på glørne.",
  "Marta tørka av benken.",
  "Marta lot døra stå åpen litt til.",
  "Marta såg mot vinduet.",
  "Marta fant fram nystekt brød.",
  "Marta satte seg uten eit ord.",
  "Marta tok inn handklea.",
  "Marta henta meir ved.",
  "Marta lot gryta putre.",
  "Marta retta på duken.",
  "Marta nikka stille.",
  "Ronny klødde sæ i nakken.",
  "Ronny såg på skruan.",
  "Ronny fant fram fastnøkkelen.",
  "Ronny slo lett på metallet.",
  "Ronny meinte det berre trengte litt omtanke.",
  "Ronny henta ein plank.",
  "Ronny såg løysinga med ein gang.",
  "Ronny blei ivrig.",
  "Ronny tok sats.",
  "Ronny lo før han prøvde igjen.",
  "Ronny fant ei ny vinkling.",
  "Ronny gav ikkje opp.",
  "Ronny såg lyst på det.",
  "Ronny pusta i hendene.",
  "Ronny tok fram arbeidshanskan.",
  "Bamse løfta snuten mot vinden.",
  "Bamse såg etter fuglan.",
  "Bamse snudde eitt øre.",
  "Bamse fann ein solflekk.",
  "Bamse la halen rundt sæ.",
  "Bamse såg mot Johannes.",
  "Bamse lukta på lufta.",
  "Bamse venta tålmodig.",
  "Bamse rista på pelsen.",
  "Bamse gjespa stille.",
  "Bamse sukka djupt.",
  "Bamse fulgte skyggen.",
  "Bamse fann trappa.",
  "Bamse tok livet med ro.",
  "Bamse såg at alle va samla.",
  "Bamse la hodet på labban.",
  "Bamse flytta sæ etter sola.",
  "Bamse blunka sakte.",
  "Bamse sovna nesten.",
  "Da vinden snudde ute ved odden.",
  "Mens sola klatra sakte opp.",
  "Da regnet slapp taket.",
  "Mens skyene dreiv stille sørover.",
  "Da tåka letta frå fjorden.",
  "Mens lufta blei klarere.",
  "Da frosten glitra på rekka.",
  "Mens snøfokken fant vegen mellom naustan.",
  "Da lyset traff sjøen først.",
  "Mens kveldslufta blei kjølig.",
  "Da dagen endelig roa sæ.",
  "Mens natta venta ute på havet.",
  "Da vinden tok en pause.",
  "Mens bølgene fant rytmen.",
  "Da himmelen blei lysare.",
  "Mens månen gjekk opp bak fjellet.",
  "Da regnet blei til yr.",
  "Mens havet låg og kvilte.",
  "Da sola forsvant bak øyan.",
  "Mens stjernan tok over.",
  "Da båten la sæ til ro.",
  "Mens fortøyninga stramma sæ litt.",
  "Da rekka tørka i vinden.",
  "Mens garnet venta på neste tur.",
  "Da moloen tok imot sjøen.",
  "Mens brygga knirka under vekta.",
  "Mens dieselukta hang igjen.",
  "Da første teine blei løfta.",
  "Mens kråkene samla sæ på kaia.",
  "Da fjorden låg blå og tung.",
  "Mens båthaken lente sæ mot veggen.",
  "Da naustdøra stod på gløtt.",
  "Mens tauverket låg pent kveila.",
  "Da sjøsprøyten nådde heilt opp.",
  "Mens fortøyningsringen klirra svakt.",
  "Da havet gjorde som havet alltid gjør.",
  "Mens kaia venta på fleire fottrinn.",
  "Da måsan slo ein ny runde.",
  "Mens bølgene viska bort sporene.",
  "Johannes kneip augan litt sammen.",
  "Johannes løfta kaffekoppen.",
  "Johannes såg utover leia.",
  "Johannes blei stående ved rekka.",
  "Johannes la handa i lomma.",
  "Johannes høyrte vinden først.",
  "Johannes lot skuldrene kvile.",
  "Johannes tok en liten pause.",
  "Johannes flytta vekta over på det andre beinet.",
  "Johannes såg etter lyset.",
  "Johannes stod uten å skynde sæ.",
  "Johannes venta på det rette ordet.",
  "Johannes lot blikket følge sjøen.",
  "Johannes snudde koppen sakte.",
  "Johannes lot tankan få gå.",
  "Johannes kjente trekken frå døra.",
  "Johannes såg på Bamse.",
  "Johannes smilte nesten usynlig.",
  "Johannes drog lua litt ned.",
  "Johannes lot stillheta få plass.",
  "Marta satte fram fleire koppa.",
  "Marta fylte kaffekanna igjen.",
  "Marta såg ut vinduet.",
  "Marta fant fram smørkniven.",
  "Marta løfta lokket av gryta.",
  "Marta tok inn veden.",
  "Marta flytta blomsterpotta.",
  "Marta la eit nytt vedtre på.",
  "Marta retta på gardina.",
  "Marta lot kaffen trekke litt til.",
  "Marta satte seg ved bordet.",
  "Marta høyrte vinden.",
  "Marta bretta sammen avisa.",
  "Marta nikka mot Johannes.",
  "Marta smilte for sæ sjøl.",
  "Marta fant fram fleire tallerkena.",
  "Marta lot praten komme av sæ sjøl.",
  "Marta tok en slurk.",
  "Marta såg mot døra.",
  "Marta lot stillheta vare.",
  "Ronny hadde olje på fingran.",
  "Ronny tørka hendene på buksa.",
  "Ronny såg på motoren.",
  "Ronny meinte det berre va ein bagatell.",
  "Ronny henta meir verktøy.",
  "Ronny fant fram hammeren.",
  "Ronny satte seg på huk.",
  "Ronny såg opp og lo.",
  "Ronny hadde allerede tenkt ut neste steg.",
  "Ronny klappa båten.",
  "Ronny prøvde ein gang til.",
  "Ronny rista på hodet med et smil.",
  "Ronny pusta letta ut.",
  "Ronny såg at det fungerte.",
  "Ronny fant ei enklare løysing.",
  "Ronny la frå sæ skiftenøkkelen.",
  "Ronny såg mot Johannes.",
  "Ronny blei ivrig igjen.",
  "Ronny meinte det holdt.",
  "Ronny tok fatt.",
  "Bamse løfta blikket.",
  "Bamse såg etter måsan.",
  "Bamse strekte ryggen.",
  "Bamse la sæ tettare inntil veggen.",
  "Bamse flytta på labban.",
  "Bamse kjente lukta av sjø.",
  "Bamse snuste mot kaffen.",
  "Bamse gjekk eit par steg.",
  "Bamse sette sæ igjen.",
  "Bamse såg mot Marta.",
  "Bamse fann varmen ved ovnen.",
  "Bamse lukka augan.",
  "Bamse lytta til vinden.",
  "Bamse lot halen ligge stille.",
  "Bamse såg mot brygga.",
  "Bamse rista litt på pelsen.",
  "Bamse fann roen.",
  "Da kaffen akkurat var helt opp.",
  "Mens dampen steg fra koppen.",
  "Da ovnsdøra klikka igjen.",
  "Mens veden tok fyr på nytt.",
  "Da regnet traff vinduskarmen.",
  "Mens vinden ruska i flagglina.",
  "Da sola traff den gamle benken.",
  "Mens skyggen flytta sæ over brygga.",
  "Da frosten slapp taket.",
  "Mens lufta lukta tang.",
  "Da sjølukta kom først.",
  "Mens naustveggen knirka.",
  "Da takrenna begynte å dryppe.",
  "Mens måsan holdt et leven.",
  "Da lyset fant kjøkkenbordet.",
  "Mens fjorden låg stille.",
  "Da himmelen åpna sæ litt.",
  "Mens snøen falt uten hastverk.",
  "Da regnet gav sæ.",
  "Da pullerten va kald å ta på.",
  "Da rekka fortsatt va våt.",
  "Mens båten drog lett i fortøyninga.",
  "Da første bølga traff brygga.",
  "Mens havet skifta humør.",
  "Da masta svarte vinden.",
  "Mens garnet lukta sjø.",
  "Da teinekroken hang på plass.",
  "Da fjorden glinsa i morgensola.",
  "Mens motoren tikka etter stopp.",
  "Da ankerkjettingen klirra.",
  "Mens brygga gynga nesten umerkelig.",
  "Da sjøsprøyten traff kinnet.",
  "Mens naustdøra stod halvåpen.",
  "Da måsan samla sæ.",
  "Mens diesel og salt blanda sæ.",
  "Da båten fann ro.",
  "Mens leia låg åpen.",
  "Johannes retta litt på lua.",
  "Johannes såg mot nord.",
  "Johannes lot koppen bli stående.",
  "Johannes lytta til kaia.",
  "Johannes venta på lyden av ein motor.",
  "Johannes stod med hendene bak ryggen.",
  "Johannes lot vinden bestemme.",
  "Johannes såg mot fyret.",
  "Johannes tok eit steg tilbake.",
  "Johannes pusta inn sjølufta.",
  "Johannes lot augan kvile.",
  "Johannes såg etter skyan.",
  "Johannes lot tankan drive.",
  "Johannes kjente sola i ansiktet.",
  "Johannes flytta koppen litt nærmere.",
  "Johannes stod som om han venta på nån.",
  "Johannes høyrte måsan.",
  "Johannes såg mot brygga.",
  "Marta satte fram sukkeret.",
  "Marta fylte koppen før ho satte sæ.",
  "Marta tok ut brødet.",
  "Marta fann fram smørboksen.",
  "Marta tørka av vinduskarmen.",
  "Marta åpna døra mot kaia.",
  "Marta såg om veden holdt.",
  "Marta la lokket på kjelen.",
  "Marta tok inn den tørre veden.",
  "Marta såg at kaffen va passe sterk.",
  "Marta la handa på stolryggen.",
  "Marta fann fram fleire krus.",
  "Marta kikka ut ei stund.",
  "Marta smilte mot Bamse.",
  "Marta satte seg rolig ned.",
  "Marta høyrte etter.",
  "Marta såg mot Johannes.",
  "Marta lot stillheta få være.",
  "Marta blei sittende.",
  "Ronny kom med kaffekoppen i handa.",
  "Ronny hadde glømt hanskan igjen.",
  "Ronny såg på motorfestet.",
  "Ronny fann fram skrallesettet.",
  "Ronny meinte det berre måtte strammes litt.",
  "Ronny lo av seg sjøl.",
  "Ronny klappa skjermen på ekkoloddet.",
  "Ronny fann fram ei fille.",
  "Ronny tørka av hendene.",
  "Ronny prøvde ein annan måte.",
  "Ronny såg at det nærma sæ.",
  "Ronny henta meir tau.",
  "Ronny la verktøyet på benken.",
  "Ronny blei stående og tenke.",
  "Ronny såg mot havet.",
  "Ronny fann på nåkka underveis.",
  "Ronny hadde ikkje dårlig tid.",
  "Ronny tok ein slurk kaffe.",
  "Ronny nikka.",
  "Ronny sette i gang.",
  "Bamse løfta hovudet frå labban.",
  "Bamse snuste mot vinden.",
  "Bamse høyrte døra først.",
  "Bamse såg mot naustet.",
  "Bamse la sæ i sola.",
  "Bamse fann ein tørr flekk.",
  "Bamse følgte Johannes med blikket.",
  "Bamse rista øyrene.",
  "Bamse gjekk rolig over golvet.",
  "Bamse stoppa ved døra.",
  "Bamse såg ut mot sjøen.",
  "Bamse fann plassen sin.",
  "Bamse pusta tungt.",
  "Bamse venta utan å mase.",
  "Bamse blunka mot lyset.",
  "Bamse høyrte noko ingen andre høyrte.",
  "Bamse la halen til ro.",
  "Bamse sukka lågt.",
  "Bamse såg at alle va der.",
  "Bamse sovna sakte.",
  "Da kaffeskjea klirra mot koppen.",
  "Mens ei flue surra mot ruta.",
  "Da radioen mista signalet ei stund.",
  "Mens vinduet dugga litt til.",
  "Da veden falt sammen med eit sukk.",
  "Mens glørne lyste under oska.",
  "Da døra slo igjen av sæ sjøl.",
  "Mens ei avis låg oppslått på bordet.",
  "Da kaffilukta fylte bua.",
  "Da golvplankan knirka.",
  "Mens ei jakke hang over stolryggen.",
  "Da kaffekoppen blei fylt enda ein gang.",
  "Mens gardina rørte sæ i trekken.",
  "Da vatnet begynte å koke.",
  "Mens skjea blei liggande på benken.",
  "Da brødkniven traff fjøla.",
  "Mens smørpapiret knitra.",
  "Da kaffeboksen blei åpna.",
  "Mens lokket klikka på plass.",
  "Da ei måse landa på taket.",
  "Mens ein ravn passerte over kaia.",
  "Da ei kråke fann nåkka interessant.",
  "Mens ternene skar gjennom lufta.",
  "Da ein skarv tørka vingan.",
  "Mens ein ørn hang over fjellet.",
  "Da måsan plutselig blei stille.",
  "Mens småfuglan fann ly.",
  "Da ei fjær dreiv forbi.",
  "Mens ei måse såg ut til å vente.",
  "Da ein sel stakk hovudet opp.",
  "Mens ein nise rulla ute på fjorden.",
  "Da måsan krangla om restan.",
  "Mens fugleskrikan bar langt.",
  "Da ei and letta frå fjæra.",
  "Mens ei fjæreplytt sprang langs steinan.",
  "Da ei måse tok vinden.",
  "Mens fuglan visste meir enn folk.",
  "Da ei fjær festa sæ i rekka.",
  "Mens lufta va full av vingar.",
  "Da ei tom bøtte stod opp ned.",
  "Mens ein fiskekniv låg att på benken.",
  "Da tauverket kasta lange skygga.",
  "Mens redningsvesten hang til tørk.",
  "Da ei oljekanne sto under benken.",
  "Mens ein gammel fender gynget.",
  "Da garnnåla låg igjen.",
  "Mens eit blått tau stakk ut av haugen.",
  "Da ein krok glinsa i sola.",
  "Mens ein teinepinne lente sæ mot veggen.",
  "Da flyteblåsa dreiv sakte.",
  "Mens båthaken sto klar.",
  "Da ein garnkasse va full av regnvatn.",
  "Mens ein stamp stod halvfull.",
  "Da ankeret kvilte på dekket.",
  "Mens ei bøye dreiv dovent.",
  "Da ein kniv låg igjen etter sløyinga.",
  "Mens ein krok hang på spikeren.",
  "Da ein hanske blei glømt ute.",
  "Mens eit tau enda i ein perfekt kveil.",
  "Johannes la handa på dørkarmen.",
  "Johannes såg etter røyken frå pipa.",
  "Johannes høyrte bølgene før han såg dei.",
  "Johannes lot kaffen bli lunken.",
  "Johannes drog stolen litt bakover.",
  "Johannes la lua på bordet.",
  "Johannes såg på den gamle klokka.",
  "Johannes lot fingran kvile rundt koppen.",
  "Johannes stod med ryggen mot vinden.",
  "Johannes såg utover som om han kjente kvar bølge.",
  "Johannes tok av brillan.",
  "Johannes tørka ruta med ermet.",
  "Johannes såg mot nausttaket.",
  "Johannes høyrte radioen i bakgrunnen.",
  "Johannes venta til vinden løya.",
  "Johannes såg mot fyrljoset.",
  "Johannes strauk handa over skjegget.",
  "Johannes lot døra stå åpen.",
  "Johannes kjente etter temperaturen.",
  "Johannes såg mot horisonten enda ein gang.",
  "Marta bretta kjøkkenhandduken.",
  "Marta tok ut ei rein skål.",
  "Marta la lokket litt på skeiv.",
  "Marta skjenkte kaffe utan å spørre.",
  "Marta fann fram syltetøyglaset.",
  "Marta flytta blomsterpotta mot lyset.",
  "Marta lot gryta stå litt til.",
  "Marta retta på kaffeduken.",
  "Marta tørka av vindauget.",
  "Marta fann fram sukkerbiten.",
  "Marta høyrte vinden ta tak i huset.",
  "Marta såg ut før ho svarte.",
  "Marta lot kaffekjelen synge ferdig.",
  "Marta sette koppen på same plassen som alltid.",
  "Marta fann fram fleire vedtre.",
  "Marta smilte mot lyset.",
  "Marta lot radioen surre.",
  "Marta såg etter Bamse.",
  "Marta høyrte på stillheta.",
  "Marta tok ein rolig pust.",
  "Ronny fann ein skrue i lomma.",
  "Ronny klødde sæ med fastnøkkelen.",
  "Ronny blåste støvet av benken.",
  "Ronny banka lett på motorlokket.",
  "Ronny såg om propellen gjekk fritt.",
  "Ronny drog i startsnora.",
  "Ronny prøvde uten å miste humøret.",
  "Ronny henta ei ny sikring.",
  "Ronny såg på Johannes før han begynte.",
  "Ronny fann fram ei lommelykt.",
  "Ronny tørka salt av brillan.",
  "Ronny la verktøyet pent tilbake.",
  "Ronny såg etter lekkasjen.",
  "Ronny henta meir diesel.",
  "Ronny fann ei ny pakning.",
  "Ronny meinte det såg lovande ut.",
  "Ronny tok eit steg tilbake.",
  "Ronny lo då det endelig fungerte.",
  "Ronny nikka fornøyd.",
  "Ronny blei stående og sjå.",
  "Bamse snuste på fiskekassen.",
  "Bamse la labben over snuten.",
  "Bamse høyrte ei måse bak naustet.",
  "Bamse såg mot døra utan å reise sæ.",
  "Bamse flytta sæ ut av trekken.",
  "Bamse fann den varme flekken på golvet.",
  "Bamse blunka mot sola.",
  "Bamse løfta berre eitt øyre.",
  "Bamse såg etter Johannes.",
  "Bamse sukka som berre Bamse kunne.",
  "Bamse lukta at kaffen va ferdig.",
  "Bamse rista litt på halen.",
  "Bamse gjekk eit par runda før han la sæ.",
  "Bamse heldt auge med alle.",
  "Bamse tok seg god tid.",
  "Bamse sov med eitt øyre våkent.",
  "Bamse la haka på støvelen.",
  "Bamse såg mot fjorden.",
  "Bamse fann roen igjen.",
  "Bamse blei liggande heilt stille.",
  "Da kaffiringen fortsatt va våt på bordet.",
  "Mens den gamle veggklokka gjekk litt seint.",
  "Da ovnen knitra lågt.",
  "Mens trekken fann vegen under døra.",
  "Da kaffekjelen småkokte.",
  "Mens dampen la sæ på ruta.",
  "Da ei skei blei liggande igjen i koppen.",
  "Mens den siste brødskiva låg på fjøla.",
  "Da smørkniven fortsatt va blank.",
  "Mens kaffilukta hang igjen i rommet.",
  "Da golvet knirka under eitt steg.",
  "Mens vedkorga begynte å bli tom.",
  "Da glørne lyste raudt.",
  "Mens ein fyrstikk brann heilt ned.",
  "Da gardina rørte lett på sæ.",
  "Mens lampa kasta gult lys over bordet.",
  "Da radioen surra meir enn han spelte.",
  "Mens stillheta tok over igjen.",
  "Da kaffen blei akkurat passe sterk.",
  "Mens ingen reiste sæ ennå.",
  "Da ein gammal fiskekasse sto skeivt.",
  "Mens eit tau hadde løyst sæ litt.",
  "Da rekka va sleip av morgendogg.",
  "Mens ein fender slo dovent mot båtsida.",
  "Da bølgene fann trappa.",
  "Mens sjøen drog sakte tilbake.",
  "Da ein liten krabbe forsvann mellom steinan.",
  "Mens tanga dansa under vatnet.",
  "Da flyteblåsa vippa rolig.",
  "Mens garnkorkane dreiv i takt.",
  "Da fjæra avslørte meir av botnen.",
  "Mens ein stein blei blank av sjøsprøyt.",
  "Da måsan tok ein ekstra runde.",
  "Mens havet gjorde resten.",
  "Da vinden fann mastene.",
  "Mens tauverket stramma sæ akkurat nok.",
  "Da naustveggen lukta tjære.",
  "Mens eit gammalt anker kvilte i graset.",
  "Da bølgene slo mjukt mot pålan.",
  "Mens leia låg open mot nord.",
  "Johannes såg etter spor i sjøen.",
  "Johannes lot handa kvile på rekka.",
  "Johannes stod med ansiktet mot vinden.",
  "Johannes høyrte noko dei andre oversåg.",
  "Johannes såg opp før han svarte.",
  "Johannes let kaffekoppen bli ståande.",
  "Johannes tok eit djupt andedrag.",
  "Johannes kjente lukta av regn.",
  "Johannes såg mot den ytste holmen.",
  "Johannes lytta til stillheta.",
  "Johannes tok av seg hansken.",
  "Johannes drog stolen nærmare bordet.",
  "Johannes strauk over bordplata.",
  "Johannes lét augan følge ei måse.",
  "Johannes såg mot det gamle naustet.",
  "Johannes rista lett på hovudet.",
  "Johannes stod heilt i ro.",
  "Johannes tok ein slurk før han sa noko.",
  "Johannes venta på rett augeblink.",
  "Johannes lot havet snakke først.",
  "Marta skauv sukkerskåla litt nærmare.",
  "Marta såg at kaffen snart va tom.",
  "Marta la meir ved i omnen.",
  "Marta tok fram ei ny pakke knekkebrød.",
  "Marta løfta lokket og kjente på lukta.",
  "Marta tørka hendene på forkleet.",
  "Marta såg mot kjøkkenvindauget.",
  "Marta fylte opp vasmugga.",
  "Marta fann fram eit ekstra glass.",
  "Marta la duken litt rettare.",
  "Marta høyrte regnet først.",
  "Marta opna døra for å sleppe inn luft.",
  "Marta lot kaffen kvile eit minutt.",
  "Marta flytta blomane bort frå trekken.",
  "Marta smilte mot lyset frå vindauget.",
  "Marta tok koppen med begge hender.",
  "Marta såg bort på Johannes.",
  "Marta nikka nesten umerkeleg.",
  "Marta lot stillheta få vere god.",
  "Marta blei sittande litt til.",
  "Ronny fann ein bolt på golvet.",
  "Ronny såg på propellen frå sida.",
  "Ronny banka lett med skaftet på skrutrekkaren.",
  "Ronny drog opp glidelåsen i jakka.",
  "Ronny henta ei ny pakke strips.",
  "Ronny fann fram multiverktøyet.",
  "Ronny såg at vatnet steig.",
  "Ronny tørka av setet i båten.",
  "Ronny prøvde ein annan vinkel.",
  "Ronny målte ein gang til.",
  "Ronny la verktøyet frå seg.",
  "Ronny såg på resultatet.",
  "Ronny nikka for seg sjølv.",
  "Ronny henta kaffekoppen før han fortsette.",
  "Ronny meinte det va verdt eit forsøk.",
  "Ronny lo då det endelig passa.",
  "Ronny kjente etter om det sat.",
  "Ronny såg opp mot skyene.",
  "Ronny blei ståande og tenke.",
  "Ronny byrja på nytt.",
  "Bamse snuste mot sjøvinden.",
  "Bamse blunka sakte mot sola.",
  "Bamse såg etter rørsla ute på brygga.",
  "Bamse fann ein lun plass ved veggen.",
  "Bamse høyrte fottrinn lenge før dei andre.",
  "Bamse strekte på frambeina.",
  "Bamse rista av seg støvet.",
  "Bamse følgde lukta av nysteikt brød.",
  "Bamse sette seg midt i døropninga.",
  "Bamse såg på kaffekoppen utan håp.",
  "Bamse heldt auge med måsan.",
  "Bamse flytta seg ein meter mot sola.",
  "Bamse sukka tungt og nøgd.",
  "Bamse la øyret mot golvet.",
  "Bamse kjente trekken frå døra.",
  "Bamse gjekk bort til Johannes.",
  "Bamse stoppa opp ved trappa.",
  "Bamse fann den same plassen som alltid.",
  "Bamse sov med eitt auge ope.",
  "Bamse venta på at nokon skulle reise seg.",
  "Da skreien venta ute i djupet.",
  "Mens leverlukta hang over kaia.",
  "Da sløyebenken blei våt.",
  "Mens måsan samla sæ rundt stampan.",
  "Da kniven fann rett spor.",
  "Mens torsken låg blank i morgonlyset.",
  "Da blodvatnet rann mot sjøen.",
  "Mens teinan stod klare ved veggen.",
  "Da første fangsten kom inn.",
  "Mens kaia fekk liv.",
  "Da mørket kom før ettermiddagen.",
  "Mens gatelysa spegla sæ i isen.",
  "Da frostrøyken stod over fjorden.",
  "Da vinden beit i øyrene.",
  "Mens isen knaka i fjæra.",
  "Da dagen nesten va over før han byrja.",
  "Mens nordlyset venta bak skyan.",
  "Da kulda fann kvar glippe.",
  "Mens stillheta blei enda stillare.",
  "Da sola aldri heilt forsvann.",
  "Mens midnattssola låg over øyan.",
  "Da klokka slutta å bety så mykje.",
  "Mens lyset blei hengande heile natta.",
  "Da skuggan blei korte.",
  "Mens fjorden glinsa heile døgnet.",
  "Da natta gløymde å komme.",
  "Mens måsan heldt fram som om det va morgon.",
  "Da lufta aldri blei heilt kald.",
  "Mens lyset fann alle krikar.",
  "Da første påskesola trefte veggen.",
  "Mens snøen begynte å gi etter.",
  "Da skaren bar støvlan.",
  "Mens bekken vakna under isen.",
  "Da takdroppet fann rytmen.",
  "Mens vårvinden tok første tak.",
  "Da sjøen fekk ny farge.",
  "Mens naustet lukta vinter og vår samtidig.",
  "Da sola varma benken.",
  "Mens dagen blei litt lengre.",
  "Da julekaffen stod klar.",
  "Mens stjerna hang i vindauget.",
  "Da vedomnen gjorde halve jobben.",
  "Mens mørket låg tett rundt huset.",
  "Da den første pepperkaka knakk.",
  "Mens lyslenka spegla sæ i ruta.",
  "Da snøen dempa alle lydar.",
  "Mens kaffen blei skjenka i dei same koppane.",
  "Da granlukta fylte rommet.",
  "Mens stillheta fekk vere julefred.",
  "Da regnbyga drog forbi.",
  "Mens sola kom fram igjen.",
  "Da vinden snudde mot vest.",
  "Mens skyene opna eit lite hol.",
  "Da havet blei mørkeblått.",
  "Mens lufta smakte regn.",
  "Da ei regnboge strekte sæ over fjorden.",
  "Mens skodda letta.",
  "Da lyset endra heile landskapet.",
  "Mens vêret ombestemte sæ.",
  "Da lukta av tjære hang igjen.",
  "Mens fersk kaffe blanda sæ med sjølufta.",
  "Da saltet tørka på rekka.",
  "Mens diesel og tang møttest.",
  "Da nybaka brød fylte bua.",
  "Mens våte klede tørka ved omnen.",
  "Mens veden lukta harpiks.",
  "Da regnet drog fram lukta av jord.",
  "Mens morgonen hadde lukt av hav.",
  "Da den gamle benken knirka.",
  "Mens kaffekoppen fann den vanlege plassen.",
  "Da støvlan stod på rekke.",
  "Mens lua hang på same spikeren.",
  "Da radioen surra lågt.",
  "Mens kalenderen fortsatt viste feil månad.",
  "Da døra stod på gløtt.",
  "Mens vindauget samla dogg.",
  "Da veggklokka tikka uforstyrra.",
  "Mens ingen såg behov for å skunde sæ.",
  "Johannes løfta blikket mot skydekket.",
  "Johannes lot vinden avgjere.",
  "Johannes såg på sjøen før menneskan.",
  "Johannes kjente etter i stillheta.",
  "Johannes let dagen starte av sæ sjølv.",
  "Johannes tok ikkje første ordet.",
  "Johannes høyrte etter mellom setningane.",
  "Johannes såg mot det som ikkje rørte sæ.",
  "Johannes fann ro ved rekka.",
  "Johannes stod som han alltid hadde stått.",
  "Marta såg at kaffen snart måtte setjast over.",
  "Marta tok koppen før nokon bad om det.",
  "Marta visste kvar alle likte å sitte.",
  "Marta fann fram det gamle fatet.",
  "Marta såg ut på vêret.",
  "Marta lot gryta putre vidare.",
  "Marta fylte vedkorga utan eit ord.",
  "Marta smilte til Bamse.",
  "Marta tok inn handkleda.",
  "Marta lot praten finne sin eigen veg.",
  "Ronny fann enda ein måte å gjere det på.",
  "Ronny meinte det berre såg verre ut enn det va.",
  "Ronny hadde alltid ein ekstra skrue.",
  "Ronny såg moglegheiter der andre såg arbeid.",
  "Ronny tørka hendene før han peikte.",
  "Ronny tok sats med eit smil.",
  "Ronny fann fram noko ingen visste fanst.",
  "Ronny hadde ikkje gitt opp.",
  "Ronny byrja ein gang til.",
  "Bamse høyrte bilen før alle andre.",
  "Bamse visste kven som kom.",
  "Bamse fann skuggen under benken.",
  "Bamse såg mot døra.",
  "Bamse løfta berre det eine øyret.",
  "Bamse venta utan uro.",
  "Bamse la seg der sola trefte golvet.",
  "Bamse heldt vakt utan å virke opptatt.",
  "Da kaia fortsatt lukta natt.",
  "Mens havet ennå ikkje hadde roa sæ.",
  "Da den første kaffedampen steg mot taket.",
  "Mens lyset listet sæ over fjellet.",
  "Da ei enslig måse prøvde stemmen sin.",
  "Da vinden gikk mellom naustan.",
  "Mens ei bølge fant den samme steinen som alltid.",
  "Da den gamle benken venta på dagens første kaffekopp.",
  "Mens kaffekjelen visste ka klokka va.",
  "Da rekka fortsatt va kald etter natta.",
  "Mens tauverket lå som det blei forlatt.",
  "Da dieselen hang igjen i lufta.",
  "Mens ei bøye nikka sakte ute på fjorden.",
  "Da båten rørte sæ før vinden gjorde det.",
  "Mens sjøsprøyten fant fram til støvlan.",
  "Da masta svarte med eit lite pip.",
  "Mens fjæra avslørte gamle spor.",
  "Da havet såg større ut enn i går.",
  "Mens leia låg open heilt mot nord.",
  "Da Johannes hadde stått ei stund allerede.",
  "Mens Johannes lot dagen komme først.",
  "Mens Johannes lot tida gå.",
  "Da Johannes tok lua av utan grunn.",
  "Mens Johannes lot kaffen bli kald.",
  "Da Johannes høyrte vinden skifte meining.",
  "Da Marta visste at kaffen trengte eitt minutt til.",
  "Mens Marta fann fram koppen som alltid blei brukt.",
  "Da Marta såg mot vinduet før ho svarte.",
  "Mens Marta lot gryta passe seg sjøl.",
  "Da Marta bretta handduken ein gang til.",
  "Mens Marta høyrte huset puste.",
  "Da Marta såg at alle hadde fått sitt.",
  "Mens Marta nikka nesten umerkeleg.",
  "Mens Marta lot dagen få begynne rolig.",
  "Da Ronny hadde skrudd fra kvarandre meir enn planlagt.",
  "Mens Ronny leita etter skruen som alltid blei borte.",
  "Da Ronny smilte til eit problem.",
  "Mens Ronny fann ei løysing ingen hadde bedt om.",
  "Da Ronny klappa motorlokket.",
  "Mens Ronny blåste bort litt rust.",
  "Da Ronny meinte det såg lovande ut.",
  "Mens Ronny ikkje gav opp.",
  "Da Bamse høyrte noko langt ute.",
  "Mens Bamse flytta sæ etter sola.",
  "Da Bamse sukka tungt.",
  "Da Bamse fann den lunaste flekken.",
  "Da Bamse såg mot Johannes.",
  "Mens Bamse la hovudet på labban.",
  "Da Bamse bestemte sæ for å bli.",
  "Mens Bamse lot dagen gå sin gang.",
  "Da skreisesongen fortsatt sat i veggan.",
  "Mens leverlukta hang att på kaia.",
  "Da sløyebenken fortalte resten.",
  "Mens garnet tørka i nordavinden.",
  "Da torsken glinsa som sølv.",
  "Mens måsan gjorde sitt beste.",
  "Da stampen blei litt tyngre.",
  "Mens kniven fann vegen av vane.",
  "Da teinene venta på floa.",
  "Mens fjorden heldt på løftet sitt.",
  "Da mørket kom stille.",
  "Mens nordlyset prøvde seg bak skyene.",
  "Da frosten tok rekka først.",
  "Mens kulda fann kvar glippe.",
  "Da snøen gjorde verda mindre.",
  "Da pusten blei synleg.",
  "Mens dagen nesten gløymde å komme.",
  "Da lykta ute på moloen stod aleine.",
  "Mens vinteren tok seg god tid.",
  "Da midnattssola nekta å gi sæ.",
  "Mens lyset blei hengande over fjorden.",
  "Da natta gløymde namnet sitt.",
  "Mens skuggane blei korte.",
  "Da klokka mista litt av makta.",
  "Da sola fann sjøen igjen.",
  "Mens lyset blei verande.",
  "Da fjorden glinsa heile natta.",
  "Da julefreden kom sjøvegen.",
  "Mens stjerna lyste i ruta.",
  "Da granlukta fylte huset.",
  "Mens vedomnen gjorde resten.",
  "Da kaffen smakte litt annleis.",
  "Mens snøen dempa alle lydar.",
  "Da stearinlysa tok over.",
  "Mens kulda blei verande ute.",
  "Da huset kjentes mindre og varmare.",
  "Mens stillheta fekk lov.",
  "Da påskesola fann benken.",
  "Mens skaren bar vekta.",
  "Da bekken byrja å snakke igjen.",
  "Mens isen sleppte taket.",
  "Da snøen fekk mørke flekka.",
  "Mens vårvinden prøvde seg.",
  "Da nausttaket begynte å dryppe.",
  "Mens lyset blei litt lenger.",
  "Da sjøen fekk vårfarge.",
  "Mens vinteren gløymde att nokre spor.",
  "Da regnet drog vidare.",
  "Mens sola tok over utan oppstyr.",
  "Da vinden roa stemmen.",
  "Mens havet blei spegelblankt.",
  "Da skyene sprakk opp.",
  "Mens lufta fekk lukt av sommar.",
  "Da regnbogen fann fjorden.",
  "Mens vêret skifta meining.",
  "Da lyset blei mjukt.",
  "Mens dagen fann balansen.",
  "Da kaffekoppen stod der han alltid stod.",
  "Mens den gamle klokka gjekk som før.",
  "Da støvlan venta ved døra.",
  "Mens radioen surra lågt.",
  "Da gardina rørte seg i trekken.",
  "Mens vedkorga snart va tom.",
  "Da benken knirka under vekta.",
  "Da huset heldt på vanane sine.",
  "Mens alt va akkurat som det skulle vere.",
  "Da havet såg ut til å vite.",
  "Mens kaia heldt på hemmeligheitene sine.",
  "Da vinden kom med gamle historier.",
  "Mens fjorden låg heilt stille.",
  "Da lyset fann vegen heim.",
  "Mens morgonen tok av seg nattelua.",
  "Da dagen pusta rolig inn.",
  "Mens stillheta gjorde resten."
 ]
};
  const T = window.OTTAR = window.OTTAR || {};
  for (const k of Object.keys(ADDITIONS)) {
    if (!Array.isArray(T[k])) T[k] = [];
    T[k] = T[k].concat(ADDITIONS[k]);
  }
})();
